(() => {
  // FD_PREVIEW_PURCHASE_GUARD_20260910_START
  const previewPurchaseProducts = {
    '9275981627642': 'fd-annie-blackout-roman-shades-blinds-plain-fold-style',
    '9275983528186': 'custom-ardenne-belgian-flax-linen-blackout-roman-shade',
    '9276034613498': 'custom-ardenne-belgian-flax-linen-plain-fold-roman-shade'
  };
  const previewPurchaseButtonSelector = '[data-fd-atc], [data-fd-sticky-submit], .fd-pdp-form button[name="add"], .fd-pdp-form input[name="add"], .fd-pdp-form button[type="submit"], .fd-pdp-form input[type="submit"]';
  const isPreviewOnlyPurchase = (root) => {
    const theme = window.Shopify && window.Shopify.theme;
    const data = root && root.dataset;
    return Boolean(data && data.fdOnlineStorePublished === 'false'
      && data.fdPreviewPurchaseTheme === '186767376634'
      && theme // theme-id gate removed 10-27 (owner): any copy of this theme behaves like live
      && String(theme.role || '').toLowerCase() === 'unpublished'
      && Object.hasOwn(previewPurchaseProducts, String(data.productId))
      && previewPurchaseProducts[String(data.productId)] === data.productHandle);
  };
  const syncPreviewPurchaseNotice = (root) => {
    const notice = root.querySelector('[data-fd-preview-purchase-notice]');
    if (!notice) return;
    const hidden = !isPreviewOnlyPurchase(root);
    if (notice.hidden !== hidden) notice.hidden = hidden;
    const message = String(root.dataset.fdPreviewPurchaseMessage || '').trim();
    if (!hidden && message && notice.textContent !== message) notice.textContent = message;
  };
  const enforcePreviewOnlyPurchaseButton = (root, button) => {
    if (!isPreviewOnlyPurchase(root)) {
      if (button.dataset.fdPreviewPurchaseLock === 'true') delete button.dataset.fdPreviewPurchaseLock;
      return false;
    }
    if (!button.disabled) button.disabled = true;
    if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
    if (button.dataset.fdPreviewPurchaseLock !== 'true') button.dataset.fdPreviewPurchaseLock = 'true';
    const text = String(root.dataset.fdPreviewPurchaseLabel || '').trim();
    if (!text) return true;
    if (button.matches('input')) {
      if (button.value !== text) button.value = text;
    } else {
      const label = button.querySelector('[data-fd-atc-text]') || button;
      if (label.textContent !== text) label.textContent = text;
    }
    return true;
  };
  const installPreviewOnlyPurchaseGuard = (root, form) => {
    if (!root || !form || root.dataset.fdPreviewPurchaseGuardReady === 'true') return;
    // No marker means this product keeps its existing purchase path untouched.
    if (root.dataset.fdPreviewPurchaseTheme !== '186767376634') return;
    root.dataset.fdPreviewPurchaseGuardReady = 'true';
    const stop = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      syncPreviewPurchaseNotice(root);
      root.querySelectorAll(previewPurchaseButtonSelector).forEach((button) => enforcePreviewOnlyPurchaseButton(root, button));
    };
    // BCPO binds its purchase callback directly to the button with jQuery.
    // Window capture runs before that target handler and before sticky proxies.
    window.addEventListener('click', (event) => {
      if (!isPreviewOnlyPurchase(root)) return;
      const button = event.target && event.target.closest && event.target.closest(previewPurchaseButtonSelector);
      if (button && root.contains(button)) stop(event);
    }, true);
    window.addEventListener('submit', (event) => {
      if (event.target === form && isPreviewOnlyPurchase(root)) stop(event);
    }, true);
  };
  // FD_PREVIEW_PURCHASE_GUARD_20260910_END
  const availabilityGuardRetryDelays = [100, 500, 1000, 2000, 4000];
  const ardenneConditionalProductId = '9275976450298';
  // FD_HEADRAIL_NEUTRAL_P0_20260910
  const isHeadrailNeutralProduct = root => ['9276037464314','9276038217978'].includes(String(root?.dataset.productId||''));
  const headrailNeutralClean = root => !isHeadrailNeutralProduct(root) || (root.dataset.fdHeadrailConstraintState === 'clean' && typeof root.__fdHeadrailNeutral?.inspectPrice === 'function');
  const readHeadrailNeutralPrice = (root,inputs) => {try{return root.__fdHeadrailNeutral?.inspectPrice(inputs)||{ready:false,reason:'headrail-runtime-missing'};}catch(error){return {ready:false,error:true,reason:'headrail-integrity-exception'};}};
  const isRoman001Product = root => String(root && root.dataset.productId || '').trim() === '9275978350842';
  const roman001ConstraintsClean = root => !isRoman001Product(root) || (
    root.dataset.fd001ConstraintState === 'clean' && typeof root.__fdRoman001?.inspectPrice === 'function'
  );
  const readRoman001PriceIntegrity = (root, inputs) => {
    if (!isRoman001Product(root)) return {ready:true};
    try {
      return root.__fdRoman001?.inspectPrice(inputs) || {ready:false,reason:'001-runtime-missing'};
    } catch (error) {
      return {ready:false,error:true,reason:'001-integrity-exception'};
    }
  };
  const isRoman015Product = root => String(root && root.dataset.productId || '').trim() === '9275983528186';
  const roman015ConstraintsClean = root => !isRoman015Product(root) || (
    root.dataset.fd015ConstraintState === 'clean' && typeof root.__fdRoman015?.inspectPrice === 'function'
  );
  const readRoman015PriceIntegrity = (root, inputs) => {
    if (!isRoman015Product(root)) return {ready:true};
    try {
      return root.__fdRoman015?.inspectPrice(inputs) || {ready:false,reason:'015-runtime-missing'};
    } catch (error) {
      return {ready:false,error:true,reason:'015-integrity-exception'};
    }
  };
  const isRoman056Product = root => String(root && root.dataset.productId || '').trim() === '9276034613498';
  const roman056ConstraintsClean = root => !isRoman056Product(root) || (
    root.dataset.fd056ConstraintState === 'clean' && typeof root.__fdRoman056?.inspectPrice === 'function'
  );
  const readRoman056PriceIntegrity = (root, inputs) => {
    if (!isRoman056Product(root)) return {ready:true};
    try {
      return root.__fdRoman056?.inspectPrice(inputs) || {ready:false,reason:'056-runtime-missing'};
    } catch (error) {
      return {ready:false,error:true,reason:'056-integrity-exception'};
    }
  };
  const isRoman014Product = root => String(root && root.dataset.productId || '').trim() === '9275981627642';
  const roman014ConstraintsClean = root => !isRoman014Product(root) || (
    root.dataset.fd014ConstraintState === 'clean' && typeof root.__fdRoman014?.inspectPrice === 'function'
  );
  const readRoman014PriceIntegrity = (root, inputs) => {
    if (!isRoman014Product(root)) return {ready:true};
    try {
      return root.__fdRoman014?.inspectPrice(inputs) || {ready:false,reason:'014-runtime-missing'};
    } catch (error) {
      return {ready:false,error:true,reason:'014-integrity-exception'};
    }
  };
  const ardenneConditionalHandles = new Set([
    'fd-custom-ardenne-belgian-flax-linen-roman-shade',
    'custom-ardenne-belgian-flax-linen-roman-shade'
  ]);
  const usesConditionalIntegrityGate = (root) => {
    if (isHeadrailNeutralProduct(root)) return true;
    const handle = String(root && root.dataset.productHandle || '').trim();
    if (handle === 'custom-textured-sheer-roman-shade') return true;
    if (String(root && root.dataset.productId || '').trim() === ardenneConditionalProductId || isRoman001Product(root) || isRoman015Product(root) || isRoman056Product(root) || isRoman014Product(root)) return true;
    return ardenneConditionalHandles.has(handle);
  };

  // FD_CONFIGURED_PURCHASE_GATE_20260922: only audited products with priced options.
  // 2026-11-04: woven bamboo sample booklets [One]/[Two]/[Four] (8699278229754, 8699280621818, 8699345010938) removed; they are plain $9.90 products with no priced options.
  // Keep free/no-addon catalog items and unpublished products on their existing paths.
  const configuredPurchaseProductIds = new Set([
    '8549981946106', '8667472199930', '8667528593658', '8672823116026', '8679078297850', '8680109310202',
    '8680116846842', '8680500560122', '8680508653818', '8685183631610', '8687156953338', '8688564699386',
    '8719728148730', '8719765373178', '8726177448186',
    '8727547379962', '8731141177594', '8731187544314', '8731874492666', '8733247045882', '8738283356410',
    '8738287943930', '8739091185914', '8903145226490', '8903312408826', '8903498694906', '8904188657914',
    '8904234762490', '8905643491578', '8905648275706', '8905662660858', '8905702670586', '8905703588090',
    '8905709322490', '8905749332218', '8905772531962', '8905773187322', '8905794912506', '8907251515642',
    '8907271438586', '8907289198842', '8907299127546', '8907307811066', '8907308466426', '8907309089018',
    '8907323310330', '8907323769082', '8907326324986', '8911850963194', '8911853781242', '8912696738042',
    '8912701063418', '8912701260026', '8912808542458', '8912827056378', '8914210128122', '8914245157114',
    '8914265080058', '8914281529594', '8915381813498', '8915382206714', '8915382894842', '8915383812346',
    '8915398590714', '8918943367418', '8918949363962', '8919051600122', '8919052222714', '8919066476794',
    '8919082369274', '8919098196218', '8919100850426', '8919630283002', '8919677763834', '8919682416890',
    '8919690084602', '8920267784442', '8920268439802', '8920338006266', '8920343445754', '8920380932346',
    '8920400560378', '8920421695738', '8920452497658', '8920464851194', '8921122930938', '8921122963706',
    '8921122996474', '8921123127546', '8921123193082', '8921123258618', '8921139249402', '8921194561786',
    '8921194758394', '8921195315450', '8921198395642', '8921210781946', '8921235226874', '8923750564090',
    '8923778384122', '8923778449658', '8923778547962', '8923780088058', '8923780481274', '8923794342138',
    '8924424175866', '8924436955386', '8924437053690', '8924437151994', '8924456648954', '8924457074938',
    '8924457861370', '8925476651258', '8925481926906', '8925484712186', '8925586948346', '8925586981114',
    '8925587046650', '8925587112186', '8925587144954', '8925587177722', '8925614342394', '8925661823226',
    '8925667262714', '8925667918074', '8925676306682', '8925676339450', '8926013161722', '8926020043002',
    '8926023352570', '8926076272890', '8926273011962', '8926273896698', '8926277632250', '8926295982330',
    '8926296637690', '8926305321210', '8926356832506', '8926362861818', '8926362894586', '8926365483258',
    '8926912413946', '8927195037946', '8927195201786', '8927195332858', '8927196545274', '8927198675194',
    '8927199035642', '8927199265018', '8927199461626', '8927199691002', '8927209292026', '8927209718010',
    '8927210635514', '8927211225338', '8927212765434', '8927233900794', '8929286193402', '8929287471354',
    '8929287504122', '8929287766266', '8929288847610', '8929289928954', '8930972631290', '8930974204154',
    '8930974335226', '8930974499066', '8930975023354', '8931006251258', '8931006972154', '8931008905466',
    '8931009396986', '8931009593594', '8931010937082', '8931011166458', '8931013460218', '8931013591290',
    '8932788109562', '8932810096890', '8932910498042', '8933322293498', '8934107513082', '8934216499450',
    '8934258147578', '8934281117946', '8934350389498', '8934371229946', '8934582321402', '8934627574010',
    '8934696517882', '8934696943866', '8934697304314', '8934698713338', '8934701334778', '8934702186746',
    '8934702481658', '8934702809338', '8937397747962', '8937406988538', '8937430253818', '8937431007482',
    '8937431826682', '8938079191290', '8938079289594', '8938079846650', '8938080207098', '8938086400250',
    '8938087022842', '8938088136954', '8938088464634', '8938088857850', '8938089742586', '8938090332410',
    '8938129162490', '8938162979066', '8938172678394', '8938175561978', '8938176610554', '8938177462522',
    '8940556714234', '8940563103994', '8940564381946', '8940566184186', '8940567331066', '8940568051962',
    '8940568674554', '8940569854202', '8940572901626', '8940998066426', '8941035389178', '8955432304890',
    '8955587002618', '8957266166010', '8957277241594', '8957294018810', '8957304930554', '8957826597114',
    '8957833511162', '8957836525818', '8957841309946', '8957872341242', '8958667129082', '8965582946554',
    '8965591695610', '8965630525690', '8965634752762', '8965635768570', '8966491177210', '8966646202618',
    '8966787006714', '8966874562810', '8967024804090', '8967043416314', '8968516010234', '8968521941242',
    '8968530133242', '8968532361466', '8968553201914', '8972067111162', '8972168495354', '8972183339258',
    '8972183896314', '8972617056506', '8972620890362', '8972622430458', '8972624199930', '8973767409914',
    '8973857521914', '8973873676538', '8974011236602', '8974014873850', '8974118682874', '8976567763194',
    '8976573661434', '8976580935930', '8976581558522', '8976582377722', '8976588603642', '8976603775226',
    '8976615342330', '8977256546554', '8978092163322', '8978093834490', '8978094031098', '8978094063866',
    '8978117591290', '8978117984506', '8981755822330', '8981756018938', '8981757198586', '8981757657338',
    '8981759852794', '8981760901370', '8983366992122', '8983373873402', '8984710283514', '8984718180602',
    '8984719130874', '8984730468602', '8984733090042', '8987177451770', '8989170663674', '8989177446650',
    '8989263757562', '8989264806138', '8989266706682', '8989267460346', '9000798650618', '9000855339258',
    '9001175974138', '9001176858874', '9001252094202', '9001253208314', '9001254027514', '9001276670202',
    '9002455236858', '9002456613114', '9002535583994', '9002536304890', '9002538336506', '9002538729722',
    '9006404305146', '9006404960506', '9006405386490', '9006406893818', '9006411677946', '9006415184122',
    '9007262728442', '9007264170234', '9007264497914', '9007268167930', '9007269249274', '9007269609722',
    '9007918514426', '9007919366394', '9007923790074', '9007932047610', '9007934472442', '9007937257722',
    '9008464855290', '9008604250362', '9008606183674', '9008610967802', '9008611590394', '9010094571770',
    '9010101518586', '9010506727674', '9010883854586', '9012422508794', '9028190503162', '9028192993530',
    '9028193091834', '9028193222906', '9029054693626', '9029078155514', '9029106270458', '9029114396922',
    '9029127667962', '9033352380666', '9033353560314', '9037798506746', '9037802537210', '9238055059706',
    '9238055649530', '9238055780602', '9238055878906', '9238056075514', '9238056272122', '9267875447034',
    '9267950682362', '9267950715130', '9267950878970', '9267950944506', '9267951829242', '9267951862010',
    '9267951927546', '9267951993082', '9267952615674', '9267952779514', '9267952845050', '9267952943354',
    '9267953107194', '9267953205498', '9267953434874', '9267953565946', '9267953729786', '9267953893626',
    '9267954057466', '9267954909434', '9267955106042', '9267955269882', '9267955826938', '9267957104890',
    '9267957268730', '9267957367034', '9267957498106', '9267957629178', '9267957858554', '9267957989626',
    '9267958153466', '9267958448378', '9267958808826', '9267959628026', '9267959693562', '9267960611066',
    '9267960709370', '9267961495802', '9267961528570', '9267962544378', '9267962577146', '9267963003130',
    '9267963068666', '9267963461882', '9267963592954', '9267964051706', '9267964182778', '9267964641530',
    '9267964739834', '9267965198586', '9267965395194', '9267965657338', '9267965821178', '9267966542074',
    '9267966804218', '9267967721722', '9267967983866', '9267968803066', '9267969032442', '9267969917178',
    '9267970081018', '9267972800762', '9267972997370', '9267974537466', '9267974635770', '9267975487738',
    '9267975684346', '9267976241402', '9267976372474', '9267977060602', '9267977421050', '9267977879802',
    '9267978273018', '9267979190522', '9267980140794', '9267981189370', '9267981549818', '9267982106874',
    '9267982762234', '9267983450362', '9267983614202', '9267984171258', '9267984236794', '9267985809658',
    '9267985907962', '9267987218682', '9267987251450', '9267988791546', '9267988922618', '9267989545210',
    '9267990233338', '9267990921466', '9267991740666', '9267992232186', '9267992690938', '9267993084154',
    '9267993641210', '9267994165498', '9267994689786', '9267994788090', '9267995148538', '9267995214074',
    '9267995672826', '9267995869434', '9267996262650', '9267996492026', '9267996721402', '9267996983546',
    '9267997147386', '9267997278458', '9267997475066', '9267997671674', '9267997835514', '9267998163194',
    '9267999015162', '9267999965434', '9268000751866', '9268000784634', '9268001308922', '9268001407226',
    '9268033716474', '9268034175226', '9268034535674', '9268034994426', '9268038107386', '9268038566138',
    '9268039942394', '9268040368378', '9268040859898', '9268041285882', '9268041679098', '9268042105082',
    '9268042465530', '9268042924282', '9268043350266', '9268044792058', '9268045218042', '9268045644026',
    '9268046102778', '9268046495994', '9268046758138', '9268047118586', '9268047970554', '9268048331002',
    '9268049084666', '9268049445114', '9268049936634', '9268050460922', '9268051181818', '9268051771642',
    '9268052295930', '9268052721914', '9268053115130', '9268053573882', '9268054524154', '9268054950138',
    '9268055343354', '9268055834874', '9268056588538', '9268057047290', '9268057669882', '9268058358010',
    '9268058816762', '9268059341050',
  ]);
  const usesConfiguredPurchaseGate = (root) => {
    const data = root && root.dataset || {};
    // The theme explicitly bypasses a foreign product's stale BCPO config for this native sample.
    const nativeSample = String(data.productId || '') === '8699278229754'
      && data.fdNativeBcpoBypass === 'true'
      && data.customizable === 'false' && data.windowTreatment === 'false';
    return !nativeSample && configuredPurchaseProductIds.has(String(data.productId || ''));
  };
  const purchasePriceLabel = (root, fallback) => {
    if (!usesConfiguredPurchaseGate(root) || root.dataset.fdPriceState === 'ready') return fallback;
    if (root.dataset.fdPriceState === 'incomplete') return 'Complete required options';
    if (root.dataset.fdPriceState === 'error') return 'Price unavailable';
    return 'Updating price…';
  };

  const installNativeAvailabilityGuard = (root) => {
    if (!root || root.dataset.fdNativeAvailabilityGuardReady === 'true') return;
    if (root.dataset.fdNativeAvailabilityGuardInitializing === 'true') return;
    root.dataset.fdNativeAvailabilityGuardInitializing = 'true';

    try {
      let purchaseTransportBusy = false;
      let releaseTransportLabel = false;
      let updateQueued = false;
      const customPurchaseFlow = root.dataset.customizable === 'true'
        || root.dataset.windowTreatment === 'true';
      const usesConditionalPriceGate = usesConditionalIntegrityGate(root);

      const getCurrentVariant = () => {
        const variantInput = root.querySelector('[data-fd-variant-id]');
        const variantJson = root.querySelector('[data-fd-variants-json]');
        if (!variantInput || !variantJson) return null;

        let variants = [];
        try {
          variants = JSON.parse(variantJson.textContent || '[]');
        } catch (error) {
          return null;
        }

        const variantId = String(variantInput.value || '');
        if (!variantId) return null;
        const variant = variants.find((item) => String(item.id) === variantId) || null;
        return variant && typeof variant.available === 'boolean' ? variant : null;
      };

      const queryPurchaseButtons = () => Array.from(new Set(root.querySelectorAll([
        '[data-fd-atc]',
        '[data-fd-sticky-submit]',
        '.fd-pdp-form button[name="add"]',
        '.fd-pdp-form input[name="add"]',
        '.fd-pdp-form button[type="submit"]',
        '.fd-pdp-form input[type="submit"]'
      ].join(', '))));

      const getButtonLabel = (button) => {
        if (!button) return '';
        if (button.matches('input')) return String(button.value || '').trim();
        const labelNode = button.matches(
          '[data-fd-atc], .fd-pdp-form button[name="add"], .fd-pdp-form button[type="submit"]'
        )
          ? button.querySelector('[data-fd-atc-text]')
          : button;
        return String(labelNode ? labelNode.textContent : button.textContent || '').trim();
      };

      const setButtonLabel = (button, label) => {
        if (!button || !label) return;
        if (button.matches('input')) {
          if (String(button.value || '').trim() !== label) button.value = label;
          return;
        }

        const isPrimaryButton = button.matches(
          '[data-fd-atc], .fd-pdp-form button[name="add"], .fd-pdp-form button[type="submit"]'
        );
        let labelNode = isPrimaryButton ? button.querySelector('[data-fd-atc-text]') : button;
        if (!labelNode && isPrimaryButton) {
          labelNode = document.createElement('span');
          labelNode.setAttribute('data-fd-atc-text', '');
          button.replaceChildren(labelNode);
        }
        if (labelNode && String(labelNode.textContent || '').trim() !== label) {
          labelNode.textContent = label;
        }
      };

      const isBusyButton = (button) => {
        if (purchaseTransportBusy || !button) return true;
        if (releaseTransportLabel) return false;
        const hasBusyFlag = button.getAttribute('aria-busy') === 'true'
          || button.classList.contains('is-loading')
          || button.dataset.loading === 'true';
        return hasBusyFlag && /^(?:Adding(?:\.{3}|…)?|Added)$/i.test(getButtonLabel(button));
      };

      const enforceNativeAvailability = () => {
        if (!root.isConnected) return;
        syncPreviewPurchaseNotice(root);
        const variant = getCurrentVariant();
        const stockAvailable = customPurchaseFlow || !variant || variant.available !== false;
        const priceGateReady = (!usesConfiguredPurchaseGate(root) || root.dataset.fdPriceState === 'ready') && (!usesConditionalPriceGate || (
          root.dataset.fdConditionalState === 'clean'
          && root.dataset.fdPriceState === 'ready'
          && headrailNeutralClean(root)
          && roman001ConstraintsClean(root) && roman015ConstraintsClean(root)
          && roman056ConstraintsClean(root)
          && roman014ConstraintsClean(root)
        ));
        const available = stockAvailable && priceGateReady;
        const label = purchasePriceLabel(root, stockAvailable ? 'Add to Cart' : 'Sold Out');
        queryPurchaseButtons().forEach((button) => {
          if (!button.isConnected) return;
          if (enforcePreviewOnlyPurchaseButton(root, button)) return;
          if (!priceGateReady) {
            if (!button.disabled) button.disabled = true;
            if (button.getAttribute('aria-disabled') !== 'true') {
              button.setAttribute('aria-disabled', 'true');
            }
            button.dataset.fdPriceLock = 'true';
            if (!isBusyButton(button)) setButtonLabel(button, label);
            return;
          }
          if (isBusyButton(button)) return;
          if (button.dataset.fdPriceLock === 'true') delete button.dataset.fdPriceLock;
          if (button.disabled === available) button.disabled = !available;
          const ariaDisabled = available ? 'false' : 'true';
          if (button.getAttribute('aria-disabled') !== ariaDisabled) {
            button.setAttribute('aria-disabled', ariaDisabled);
          }
          setButtonLabel(button, label);
        });
        releaseTransportLabel = false;
      };

      const scheduleNativeAvailability = () => {
        if (updateQueued) return;
        updateQueued = true;
        Promise.resolve().then(() => {
          updateQueued = false;
          enforceNativeAvailability();
        });
      };

      enforceNativeAvailability();

      // FD-CODEX-PDP-AVAILABILITY-SCOPE-20260817: observe purchase state, not every size keystroke.
      const observer = new MutationObserver(scheduleNativeAvailability);
      const observePurchaseTargets = () => {
        observer.disconnect();
        queryPurchaseButtons().forEach((button) => {
          if (!button || !button.isConnected) return;
          observer.observe(button, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
            childList: true,
            characterData: true,
            subtree: true
          });
        });
        if (usesConditionalPriceGate || usesConfiguredPurchaseGate(root)) {
          observer.observe(root, {
            attributes: true,
            attributeFilter: ['data-fd-price-state', 'data-fd-conditional-state', 'data-fd-headrail-constraint-state', 'data-fd001-constraint-state', 'data-fd015-constraint-state', 'data-fd056-constraint-state', 'data-fd014-constraint-state']
          });
        }
      };
      observePurchaseTargets();

      root.addEventListener('fd:purchase-transport', (event) => {
        purchaseTransportBusy = Boolean(event && event.detail && event.detail.busy);
        if (!purchaseTransportBusy) {
          releaseTransportLabel = true;
          scheduleNativeAvailability();
        }
      });
      root.addEventListener('fd:variant-updated', () => {
        observePurchaseTargets();
        scheduleNativeAvailability();
      });

      root.dataset.fdNativeAvailabilityGuardReady = 'true';
      delete root.dataset.fdNativeAvailabilityGuardInitializing;
      delete root.dataset.fdNativeAvailabilityGuardRetry;
      delete root.dataset.fdNativeAvailabilityGuardError;

      availabilityGuardRetryDelays.forEach((delay) => {
        window.setTimeout(scheduleNativeAvailability, delay);
      });
    } catch (error) {
      delete root.dataset.fdNativeAvailabilityGuardReady;
      delete root.dataset.fdNativeAvailabilityGuardInitializing;
      root.dataset.fdNativeAvailabilityGuardError = 'true';
      const retryAttempt = Number(root.dataset.fdNativeAvailabilityGuardRetry || '0');
      if (retryAttempt < availabilityGuardRetryDelays.length) {
        root.dataset.fdNativeAvailabilityGuardRetry = String(retryAttempt + 1);
        window.setTimeout(
          () => installNativeAvailabilityGuard(root),
          availabilityGuardRetryDelays[retryAttempt]
        );
      }
    }
  };

  const initialize = (root) => {
    if (!root) return;
    installNativeAvailabilityGuard(root);
    if (root.dataset.fdP0Ready === 'true') return;
    root.dataset.fdP0Ready = 'true';

    const form = root.querySelector('.fd-pdp-form');
    installPreviewOnlyPurchaseGuard(root, form);
    const isRoman001 = isRoman001Product(root);
    const isRoman015 = isRoman015Product(root);
    const isRoman056 = isRoman056Product(root);
    const isRoman014 = isRoman014Product(root);
    const variantInput = root.querySelector('[data-fd-variant-id]');
    const variantJson = root.querySelector('[data-fd-variants-json]');
    const isWindowTreatment = root.dataset.windowTreatment === 'true';
    let isCustomizable = usesConfiguredPurchaseGate(root) || isWindowTreatment || root.dataset.customizable === 'true';
    const basePriceNodes = Array.from(root.querySelectorAll('[data-fd-base-price]'));
    const primaryPriceNodes = Array.from(root.querySelectorAll('[data-fd-primary-price]'));
    const primaryPriceLabels = Array.from(root.querySelectorAll('[data-fd-primary-price-label]'));
    const primaryPriceWraps = Array.from(root.querySelectorAll('[data-fd-primary-price-wrap]'));
    const configuredPriceNodes = Array.from(root.querySelectorAll('[data-fd-price], [data-fd-sticky-price]'));
    const addOnPriceNodes = Array.from(root.querySelectorAll('[data-fd-addon-price]'));
    const lineTotalNodes = Array.from(root.querySelectorAll('[data-fd-line-total]'));
    const orderQuantityNodes = Array.from(root.querySelectorAll('[data-fd-order-quantity]'));
    const savingsNodes = Array.from(root.querySelectorAll('[data-fd-savings]'));
    const comparePriceNodes = Array.from(root.querySelectorAll('[data-fd-compare-price]'));
    // C96 (review Claude-95 P2-7): the lowest add-on the required options cost (server, from bcpo_data),
    // so "Starting at" shows the lowest price the product can really be bought at. Display only.
    const startingAddOnCents = (() => {
      const node = root.querySelector('[data-fd-starting-addon-cents]');
      const cents = node ? Number(node.getAttribute('data-fd-starting-addon-cents')) : 0;
      return Number.isSafeInteger(cents) && cents > 0 ? cents : 0;
    })();
    const quantityInput = root.querySelector('[data-fd-quantity]');
    const purchaseButtonSelector = [
      '[data-fd-atc]',
      '[data-fd-sticky-submit]',
      '.fd-pdp-form button[name="add"]',
      '.fd-pdp-form input[name="add"]',
      '.fd-pdp-form button[type="submit"]',
      '.fd-pdp-form input[type="submit"]'
    ].join(', ');
    const queryPurchaseButtons = () => Array.from(root.querySelectorAll(purchaseButtonSelector));
    let purchaseButtons = queryPurchaseButtons();
    let purchaseButtonObserver = null;
    const currency = String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD').toUpperCase();
    let variants = [];
    let priceState = isCustomizable ? 'loading' : 'ready';
    let lastAddOnSignature = '';
    let stableAddOnReads = 0;
    let confirmationFrame = 0;
    let bcpoMissingFinal = false;
    let latestSnapshot = null;
    let selectionGeneration = 0;
    let priceMutationConfirmedGeneration = 0;
    let lastObservedSelectionSignature = '';
    let confirmationNotBefore = 0;
    let priceConfirmationDeadline = Date.now() + 8000;
    let snapshotRevision = 0;
    let lastSnapshotMaterialSignature = '';
    let purchaseTransportBusy = false;
    let pendingSelectionSignature = '';
    let lastStableSelectionSignature = '';
    let stableSelectionReads = 0;
    let selectionChangedAt = 0;
    const selectionSettleMs = 650;
    const mutationQuietMs = 650;
    const stableReadIntervalMs = 100;
    const unchangedPriceConfirmationMs = 2200;
    const priceConfirmationTimeoutMs = 8000;
    const guardedColorProducts = new Map([
      ['custom-ivy-motorized-bamboo-shades-blinds', '9267957629178'],
      ['custom-natural-motorized-bamboo-shades-blinds', '9267981189370'],
      ['custom-nomi-motorized-bamboo-shades-blinds', '9267998163194']
    ]);
    const colorPriceGuardVersion = 'negative-color-v2';

    try {
      variants = JSON.parse(variantJson ? variantJson.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    const getCurrentVariant = () => {
      if (!variants.length || !variantInput) return null;
      const variantId = variantInput ? String(variantInput.value || '') : '';
      if (!variantId) return null;
      return variants.find((item) => String(item.id) === variantId) || null;
    };

    const updateBasePrice = () => {
      if (!variantInput || !basePriceNodes.length || !variants.length) return;
      const variant = getCurrentVariant();
      if (!variant) return;
      const formatted = variant.price_formatted || formatConfiguredPrice(Number(variant.price) || 0);
      basePriceNodes.forEach((node) => {
        if (node.textContent !== formatted) node.textContent = formatted;
      });
      if (!isCustomizable) {
        primaryPriceNodes.forEach((node) => {
          if (node.textContent !== formatted) node.textContent = formatted;
        });
      }
    };

    // C96 (review Claude-95 P2-6): a shown price that includes option add-ons (configured, or the
    // starting price above) is never next to the struck base compare-at price or its "Save" line.
    const shownPriceIncludesAddOns = () => isCustomizable && (priceState === 'ready'
      ? Boolean(latestSnapshot && latestSnapshot.state === 'ready' && (latestSnapshot.addOnCents || 0) > 0)
      : startingAddOnCents > 0);

    const updateSavings = () => {
      if (shownPriceIncludesAddOns()) {
        comparePriceNodes.forEach((node) => { node.hidden = true; });
        savingsNodes.forEach((node) => { node.hidden = true; });
        return;
      }
      const variant = getCurrentVariant();
      const priceCents = variant && Number.isFinite(Number(variant.price)) ? Number(variant.price) : 0;
      const compareCents = variant && Number.isFinite(Number(variant.compare_at_price)) ? Number(variant.compare_at_price) : 0;
      const savingsCents = compareCents > priceCents ? compareCents - priceCents : 0;
      comparePriceNodes.forEach((node) => {
        node.hidden = !savingsCents;
        if (savingsCents) node.textContent = formatConfiguredPrice(compareCents);
      });
      savingsNodes.forEach((node) => {
        if (!savingsCents || !compareCents) {
          if (!node.hidden) node.hidden = true;
          return;
        }
        const percent = Math.round((savingsCents / compareCents) * 100);
        const label = String(node.dataset.fdSaveLabel || 'Save');
        const savingsText = `${label} ${formatConfiguredPrice(savingsCents)} (${percent}%)`;
        if (node.textContent !== savingsText) node.textContent = savingsText;
        if (node.hidden) node.hidden = false;
      });
    };

    let headrailAddonReading=null,headrailAddonBridgeBound=false;
    let fd50SeriesAddonReading=null,fd50SeriesAddonBridgeBound=false,roman001AddonReading=null,roman001AddonBridgeBound=false;
    let roman014AddonReading=null,roman014AddonBridgeBound=false;
    const getBcpoAddOnReading = () => {if(String(window.Shopify?.theme?.role).toLowerCase()==='unpublished'&&["9276036546810","9276036776186","9276032385274","9276037595386","9276038775034","9276038709498","9276037660922","9276035760378","9276032155898","9276031926522","9275984773370","9275977793786","9276033106170","9276033204474","9275982708986","9275984412922","9276038119674","9276033564922","9276037366010","9276038873338","9276037923066","9276037857530","9275982119162","9276035203322","9275985264890","9275980775674","9276037103866","9275975336186","9275974189306","9276038611194","9276033695994","9276034744570","9276035399930","9275979170042","9276034580730","9276038447354","9276032778490","9275972845818","9276036743418","9276035596538","9276032286970","9276032844026","9276032319738"].includes(String(root.dataset.productId))){if(!fd50SeriesAddonReading)return {ready:false,cents:null,signature:'fd50-series-event-pending'};if(fd50SeriesAddonReading.invalid)return {ready:false,cents:null,signature:'fd50-series-event-invalid'};const reading=fd50SeriesAddonReading;if(reading.variantId!==String(getCurrentVariant()?.id)||reading.signature!==getObservedConfigurationSignature())return {ready:false,cents:null,signature:'fd50-series-event-stale'};return {ready:true,cents:reading.cents,signature:'fd50-series-event:'+reading.cents};}
      if(isHeadrailNeutralProduct(root)&&headrailAddonReading){
        if(headrailAddonReading.invalid)return {ready:false,cents:null,signature:'invalid-headrail-addon-event'};
        const same=headrailAddonReading.signature===JSON.stringify(root.__fdHeadrailNeutral?.readSelections())&&headrailAddonReading.variantId===String(getCurrentVariant()?.id);
        if(!same)return {ready:false,cents:null,signature:'stale-headrail-addon-event'};
        return {ready:true,cents:headrailAddonReading.cents,signature:'headrail-event-cents:'+headrailAddonReading.cents};
      }
      if(isRoman001&&roman001AddonReading){
        if(roman001AddonReading.invalid)return {ready:false,cents:null,signature:'invalid-001-addon-event'};
        const same=roman001AddonReading.signature===getObservedConfigurationSignature() && roman001AddonReading.variantId===String(getCurrentVariant()?.id);
        if(!same)return {ready:false,cents:null,signature:'stale-001-addon-event'};
        return {ready:true,cents:roman001AddonReading.cents,signature:'001-event-cents:'+roman001AddonReading.cents};
      }
      if(isRoman014&&roman014AddonReading){
        if(roman014AddonReading.invalid)return {ready:false,cents:null,signature:'invalid-014-addon-event'};
        const same=roman014AddonReading.signature===getObservedConfigurationSignature() && roman014AddonReading.variantId===String(getCurrentVariant()?.id);
        if(!same)return {ready:false,cents:null,signature:'stale-014-addon-event'};
        return {ready:true,cents:roman014AddonReading.cents,signature:'014-event-cents:'+roman014AddonReading.cents};
      }
      // 11-01 (owner): non-window products (bedding, table linen, towels, throws...). After a native variant
      // switch (bedding colour cards) VO stops refreshing .bcpo-addons-price (it adds the add-on to the product
      // price instead), so that text goes stale or empty and the guard locked add-to-cart. Read the add-on the
      // way VO computes it: in each visible .bcpo-simple group, the data-price (dollars) of the chosen value(s).
      if (root.dataset.windowTreatment !== 'true') {
        const voRoot = getBcpoRoot();
        if (voRoot) {
          let voDollars = 0;
          voRoot.querySelectorAll('.bcpo-simple').forEach((group) => {
            const first = group.children[0];
            if (!first || !(first.offsetWidth || first.offsetHeight || first.getClientRects().length)) return;
            const picked = Array.from(group.querySelectorAll('input:checked, select option:checked, input[type="file"], input[type="text"], input[type="number"], textarea'));
            if (!picked.length) return;
            const chosen = picked[0].type === 'checkbox' ? picked.map((p) => p.value).join(', ') : String(picked[0].value || '');
            if (!chosen) return;
            let amount = 0;
            if (picked.length === 1) amount = Number(picked[0].getAttribute('data-price'));
            else picked.forEach((p) => { amount += Number(p.getAttribute('data-price')) || 0; });
            if (amount && Number.isFinite(amount)) voDollars += amount;
          });
          const voCents = Math.round(voDollars * 100);
          if (Number.isSafeInteger(voCents)) return { ready: true, cents: voCents, signature: `vo-sum-cents:${voCents}` };
        }
      }
      const addOnNode = root.querySelector('.bcpo-addons-price') || document.querySelector('.bcpo-addons-price');
      if (!addOnNode) return { ready: false, cents: null, signature: 'missing' };
      const text = String(addOnNode.textContent || '').replace(/\u00a0/g, ' ').trim();
      const normalized = text.replace(/,/g, '');
      const currencyMatch = normalized.match(/(-?)\s*(?:USD|US\$|\$)\s*(-?\d+(?:\.\d{1,2})?)/i);
      const numericMatches = Array.from(normalized.matchAll(/-?\d+(?:\.\d{1,2})?/g));
      const amountText = currencyMatch
        ? `${currencyMatch[1] === '-' && !currencyMatch[2].startsWith('-') ? '-' : ''}${currencyMatch[2]}`
        : numericMatches.length
          ? numericMatches[numericMatches.length - 1][0]
          : '';
      if (!amountText) return { ready: false, cents: null, signature: `invalid:${text}` };
      const amount = Number(amountText);
      if (!Number.isFinite(amount)) {
        return { ready: false, cents: null, signature: `invalid:${text}` };
      }
      const cents = Math.round(amount * 100);
      return { ready: true, cents, signature: `cents:${cents}` };
    };

    const getGuardedColorReading = () => {
      const handle = String(root.dataset.productHandle || '').trim().toLowerCase();
      const expectedProductId = guardedColorProducts.get(handle);
      if (!expectedProductId) {
        return { required: false, selected: false, valid: true, cents: null };
      }
      if (String(root.dataset.productId || '').trim() !== expectedProductId) {
        return { required: true, selected: true, valid: false, cents: null };
      }

      const bcpoRoot = getBcpoRoot();
      if (!bcpoRoot) {
        return { required: true, selected: false, valid: false, cents: null };
      }

      const radio = bcpoRoot.querySelector('input[name="properties[Color]"]:checked');
      const select = bcpoRoot.querySelector('select[name="properties[Color]"]');
      const control = radio || select;
      if (!control || !String(control.value || '').trim()) {
        return { required: true, selected: false, valid: false, cents: null };
      }

      const selectedOption = control.tagName === 'SELECT'
        ? control.options[control.selectedIndex]
        : null;
      const rawPriceValue = control.getAttribute('data-price')
        ?? (selectedOption && selectedOption.getAttribute('data-price'));
      const rawPrice = String(rawPriceValue == null ? '' : rawPriceValue).trim();
      if (!/^[+-]?\d+(?:\.\d{1,2})?$/.test(rawPrice)) {
        return { required: true, selected: true, valid: false, cents: null };
      }

      const amount = Number(rawPrice);
      const cents = Math.round(amount * 100);
      return {
        required: true,
        selected: true,
        valid: Number.isFinite(amount) && Number.isSafeInteger(cents),
        cents: Number.isFinite(amount) && Number.isSafeInteger(cents) ? cents : null
      };
    };

    const formatConfiguredPrice = (cents) => {
      try {
        return `${new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100)} ${currency}`;
      } catch (error) {
        return `$${(cents / 100).toFixed(2)} ${currency}`;
      }
    };

    const normalizeText = (value) => String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const getBcpoRoot = () => {
      const bcpoRoot = root.querySelector('#bcpo') || (
        document.querySelectorAll('[data-fd-product]').length === 1 ? document.querySelector('#bcpo') : null
      );
      if (bcpoRoot && bcpoRoot.querySelector('input, select, textarea, [data-option], .selector-wrapper, .bold_option')) {
        isCustomizable = true;
        root.dataset.customizable = 'true';
      }
      return bcpoRoot;
    };

    const getWrapperTitle = (wrapper) => {
      const heading = wrapper && wrapper.querySelector
        ? wrapper.querySelector('.bcpo-title, .bcpo-label, .bold_option_title, legend, label')
        : null;
      return String(
        wrapper && (wrapper.dataset.optionTitle || wrapper.dataset.option || wrapper.dataset.bcpoOption)
        || heading && heading.textContent
        || ''
      ).replace(/\s*\*+\s*$/, '').trim();
    };

    const requiredWrapperSelector = [
      '.selector-wrapper',
      '.bcpo-selector-wrapper',
      '.bold_option',
      '[data-option]'
    ].join(', ');
    const requiredTitleSelector = '.bcpo-title, .bcpo-label, .bold_option_title, legend';
    const usesSemanticRequiredCache = usesConditionalIntegrityGate(root);

    const getEligibleRequiredControls = (wrapper) => Array.from(
      wrapper && wrapper.querySelectorAll ? wrapper.querySelectorAll('input, select, textarea') : []
    ).filter((control) => (
      !control.disabled
      && control.type !== 'hidden'
      && !String(control.name || '').includes('[_fd_')
    ));

    const isRequiredWrapper = (wrapper, controls = getEligibleRequiredControls(wrapper)) => {
      if (!wrapper || !controls.length) return false;
      const titleText = String((wrapper.querySelector(requiredTitleSelector) || {}).textContent || '');
      return controls.some((control) => control.required || control.getAttribute('aria-required') === 'true')
        || wrapper.getAttribute('aria-required') === 'true'
        || /\brequired\b/i.test(wrapper.className || '')
        || /\*/.test(titleText);
    };

    // Keep the original computed-style path for every other product. The
    // targeted Roman shade uses the semantic cache below so its price click
    // path never forces layout while BCPO is rebuilding the option tree.
    const getActiveRequiredWrappers = () => {
      const bcpoRoot = getBcpoRoot();
      if (!bcpoRoot) return [];
      const wrappers = Array.from(bcpoRoot.querySelectorAll(requiredWrapperSelector));
      return wrappers.filter((wrapper) => {
        const controls = getEligibleRequiredControls(wrapper);
        if (!controls.length) return false;
        if (!isRequiredWrapper(wrapper, controls)) return false;

        const mappedHidden = wrapper.classList.contains('fd-bcpo-template-hidden')
          && wrapper.dataset.fdVoSyncConfirmed === 'true';
        const conditionallyInactive = !mappedHidden && (
          wrapper.hidden
          || wrapper.getAttribute('aria-hidden') === 'true'
          || window.getComputedStyle(wrapper).display === 'none'
        );
        return !conditionallyInactive;
      });
    };

    const controlsHaveValue = (controls) => {
      if (!controls.length) return false;
      const radios = controls.filter((control) => control.type === 'radio');
      if (radios.length) return radios.some((control) => control.checked && String(control.value || '').trim() !== '');
      const checkboxes = controls.filter((control) => control.type === 'checkbox');
      if (checkboxes.length) return checkboxes.some((control) => control.checked);
      return controls.some((control) => {
        const value = String(control.value == null ? '' : control.value).trim();
        if (!value) return false;
        if (control.tagName === 'SELECT') {
          const selected = control.options && control.options[control.selectedIndex];
          if (selected && (selected.disabled || selected.dataset.placeholder === 'true')) return false;
        }
        return true;
      });
    };

    const wrapperHasValue = (wrapper) => controlsHaveValue(getEligibleRequiredControls(wrapper));

    let semanticRequiredCacheRoot = null;
    let semanticRequiredCacheRecords = new Map();
    let semanticRequiredCacheOrder = [];
    let semanticRequiredStructureDirty = true;
    let semanticRequiredValuesDirty = true;
    const semanticRequiredDirtyWrappers = new Set();

    const readSemanticRequiredRecord = (wrapper) => {
      const controls = getEligibleRequiredControls(wrapper);
      const required = isRequiredWrapper(wrapper, controls);
      const mappedHidden = wrapper.classList.contains('fd-bcpo-template-hidden')
        && wrapper.dataset.fdVoSyncConfirmed === 'true';
      const blockedAncestor = wrapper.closest(
        '[hidden], [aria-hidden="true"], .fd-bcpo-force-hidden, [data-fd-vo-unavailable="true"]'
      );
      const inlineDisplay = String(wrapper.style && wrapper.style.display || '').trim().toLowerCase();
      const inlineVisibility = String(wrapper.style && wrapper.style.visibility || '').trim().toLowerCase();
      const explicitlyInactive = wrapper.dataset.fdRequiredActive === 'false'
        || Boolean(blockedAncestor)
        || inlineDisplay === 'none'
        || inlineVisibility === 'hidden';
      return {
        wrapper,
        controls,
        title: getWrapperTitle(wrapper),
        required,
        // A confirmed proxy owns the visible UI while its native BCPO wrapper
        // remains hidden. Preserve the legacy rule that it is still active.
        active: Boolean(required && controls.length && (mappedHidden || !explicitlyInactive)
          && (!isHeadrailNeutralProduct(root) || wrapper.dataset.fdHeadrailConstraintHidden !== 'true')
          && (!isRoman001 || wrapper.dataset.fd001ConstraintHidden !== 'true')
          && (!isRoman015 || wrapper.dataset.fd015ConstraintHidden !== 'true')
          && (!isRoman056 || wrapper.dataset.fd056ConstraintHidden !== 'true')
          && (!isRoman014 || wrapper.dataset.fd014ConstraintHidden !== 'true')),
        hasValue: controlsHaveValue(controls)
      };
    };

    const invalidateSemanticRequiredStructure = () => {
      if (!usesSemanticRequiredCache) return;
      semanticRequiredStructureDirty = true;
      semanticRequiredValuesDirty = true;
      semanticRequiredDirtyWrappers.clear();
    };

    const invalidateSemanticRequiredValues = () => {
      if (!usesSemanticRequiredCache) return;
      semanticRequiredValuesDirty = true;
    };

    const invalidateSemanticRequiredNode = (node) => {
      if (!usesSemanticRequiredCache || semanticRequiredStructureDirty) return;
      const element = node && node.nodeType === 1 ? node : node && node.parentElement;
      if (!element || !semanticRequiredCacheRoot) return;

      let ancestor = element;
      while (ancestor && semanticRequiredCacheRoot.contains(ancestor)) {
        if (semanticRequiredCacheRecords.has(ancestor)) semanticRequiredDirtyWrappers.add(ancestor);
        if (ancestor === semanticRequiredCacheRoot) break;
        ancestor = ancestor.parentElement;
      }
      if (!element.querySelectorAll) return;
      element.querySelectorAll(requiredWrapperSelector).forEach((wrapper) => {
        if (semanticRequiredCacheRecords.has(wrapper)) semanticRequiredDirtyWrappers.add(wrapper);
      });
    };

    const rebuildSemanticRequiredCache = () => {
      const bcpoRoot = getBcpoRoot();
      semanticRequiredCacheRoot = bcpoRoot || null;
      semanticRequiredCacheRecords = new Map();
      semanticRequiredCacheOrder = [];
      semanticRequiredDirtyWrappers.clear();
      semanticRequiredStructureDirty = false;
      semanticRequiredValuesDirty = false;
      if (!bcpoRoot) return;

      semanticRequiredCacheOrder = Array.from(bcpoRoot.querySelectorAll(requiredWrapperSelector));
      semanticRequiredCacheOrder.forEach((wrapper) => {
        semanticRequiredCacheRecords.set(wrapper, readSemanticRequiredRecord(wrapper));
      });
    };

    const refreshSemanticRequiredCache = () => {
      const bcpoRoot = getBcpoRoot();
      if (
        semanticRequiredStructureDirty
        || bcpoRoot !== semanticRequiredCacheRoot
        || semanticRequiredCacheOrder.some((wrapper) => !wrapper.isConnected)
      ) {
        rebuildSemanticRequiredCache();
      }

      if (semanticRequiredDirtyWrappers.size) {
        semanticRequiredDirtyWrappers.forEach((wrapper) => {
          if (!wrapper.isConnected || !semanticRequiredCacheRoot || !semanticRequiredCacheRoot.contains(wrapper)) {
            semanticRequiredStructureDirty = true;
            return;
          }
          semanticRequiredCacheRecords.set(wrapper, readSemanticRequiredRecord(wrapper));
        });
        semanticRequiredDirtyWrappers.clear();
        if (semanticRequiredStructureDirty) rebuildSemanticRequiredCache();
      }

      if (semanticRequiredValuesDirty) {
        semanticRequiredCacheOrder.forEach((wrapper) => {
          const record = semanticRequiredCacheRecords.get(wrapper);
          if (record) record.hasValue = controlsHaveValue(record.controls);
        });
        semanticRequiredValuesDirty = false;
      }
    };

    const getSemanticRequiredGate = () => {
      const bcpoRoot = getBcpoRoot();
      if (!bcpoRoot) return { ready: false, mappingBlocked: false, reason: 'bcpo-missing' };
      if (!headrailNeutralClean(root)) return {ready:false,mappingBlocked:false,priceError:root.dataset.fdHeadrailConstraintState==='error',reason:'headrail-source-constraints-pending'};
      if (!roman014ConstraintsClean(root)) return {ready:false,mappingBlocked:false,priceError:root.dataset.fd014ConstraintState==='error',reason:'014-source-constraints-pending'};
      if (!roman056ConstraintsClean(root)) return {
        ready: false, mappingBlocked: false,
        priceError: root.dataset.fd056ConstraintState === 'error', reason: '056-source-constraints-pending'
      };
      if (!roman001ConstraintsClean(root)) return {
        ready: false, mappingBlocked: false,
        priceError: root.dataset.fd001ConstraintState === 'error', reason: '001-source-constraints-pending'
      };
      if (!roman015ConstraintsClean(root)) return {
        ready: false, mappingBlocked: false,
        priceError: root.dataset.fd015ConstraintState === 'error', reason: '015-source-constraints-pending'
      };
      const conditionalState = String(root.dataset.fdConditionalState || '');
      if (conditionalState === 'error') {
        return {
          ready: false,
          mappingBlocked: false,
          priceError: true,
          reason: 'conditional-state-error'
        };
      }
      if (conditionalState !== 'clean') {
        return { ready: false, mappingBlocked: false, reason: 'conditional-state-pending' };
      }
      if (root.dataset.fdProductTwopagesLivefixReady !== 'true') {
        return { ready: false, mappingBlocked: false, reason: 'livefix-pending' };
      }
      if (!root.querySelector('[data-fd-vo-template]')) {
        return { ready: false, mappingBlocked: false, reason: 'template-missing' };
      }

      const mappingState = String(root.dataset.fdVoMappingError || '');
      if (mappingState === 'true') {
        return { ready: false, mappingBlocked: true, reason: 'mapping-error' };
      }
      if (mappingState !== 'false') {
        return { ready: false, mappingBlocked: false, reason: 'mapping-pending' };
      }
      if (root.dataset.fdNativeBcpoReady === 'false') {
        return { ready: false, mappingBlocked: false, reason: 'native-bcpo-pending' };
      }
      const trimBridgeState = String(bcpoRoot.dataset.fdBcpoTrimBridgeConfirmed || '');
      if (trimBridgeState === 'pending' || trimBridgeState === 'false') {
        return { ready: false, mappingBlocked: false, reason: 'trim-bridge-pending' };
      }
      return { ready: true, mappingBlocked: false, reason: '' };
    };

    const getRequiredValidationSnapshot = () => {
      if (!usesSemanticRequiredCache) {
        return {
          ready: true,
          mappingBlocked: root.dataset.fdVoMappingError === 'true',
          reason: '',
          titles: getActiveRequiredWrappers()
            .filter((wrapper) => !wrapperHasValue(wrapper))
            .map(getWrapperTitle)
            .filter(Boolean)
        };
      }

      const gate = getSemanticRequiredGate();
      if (!gate.ready) return { ...gate, titles: [] };
      refreshSemanticRequiredCache();
      if (!semanticRequiredCacheOrder.length) {
        return { ready: false, mappingBlocked: false, reason: 'required-cache-empty', titles: [] };
      }
      return {
        ready: true,
        mappingBlocked: false,
        reason: '',
        titles: semanticRequiredCacheOrder
          .map((wrapper) => semanticRequiredCacheRecords.get(wrapper))
          .filter((record) => record && record.required && record.active && !record.hasValue)
          .map((record) => record.title)
          .filter(Boolean)
      };
    };

    const getIncompleteRequiredTitles = () => getRequiredValidationSnapshot().titles;

    const canonicalPropertyValue = (value) => String(value == null ? '' : value)
      .replace(/\s*\|\s*-?\s*(?:(?:US|CA|C)?\$|USD|CAD|EUR|GBP)\s*-?\s*[0-9,]+(?:\.[0-9]{1,2})?\s*$/i, '')
      .trim();

    const propertyNameFromControl = (name) => {
      const match = String(name || '').trim().match(/^properties\[(.+)\]$/);
      return match ? match[1].trim() : '';
    };

    const getOriginalSelectionPairs = () => {
      const bcpoRoot = getBcpoRoot();
      const controls = form
        ? Array.from(form.elements || [])
        : bcpoRoot
          ? Array.from(bcpoRoot.querySelectorAll('input, select, textarea'))
          : [];
      const pairs = [];
      controls.forEach((control) => {
        if (control.disabled) return;
        const name = String(control.name || '').trim();
        if (!name || !name.includes('properties[') || name.includes('properties[_fd_')) return;
        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
        const propertyName = propertyNameFromControl(name);
        const value = canonicalPropertyValue(control.value);
        if (!propertyName || !value) return;
        pairs.push(`${propertyName}=${value}`);
      });
      return Array.from(new Set(pairs)).sort();
    };

    const getObservedConfigurationSignature = (selectionPairs = getOriginalSelectionPairs()) => [
      `variant=${variantInput ? String(variantInput.value || '') : ''}`,
      ...selectionPairs
    ].join('\n');

    const selectionChecksum = (pairs) => {
      const text = pairs.join('\n');
      let hash = 2166136261;
      for (let index = 0; index < text.length; index += 1) {
        hash ^= text.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
      }
      return `fnv1a-${(hash >>> 0).toString(16).padStart(8, '0')}`;
    };

    const getOptionSchemaHash = () => {
      const bcpoRoot = getBcpoRoot();
      if (!bcpoRoot) return '';
      const schemaPairs = Array.from(bcpoRoot.querySelectorAll(
        '.selector-wrapper, .bcpo-selector-wrapper, .bold_option, [data-option]'
      )).map((wrapper) => {
        const controls = Array.from(wrapper.querySelectorAll('input, select, textarea'))
          .filter((control) => control.type !== 'hidden');
        const identifiers = controls.map((control) => [
          String(control.name || ''),
          String(control.type || control.tagName || ''),
          control.required || control.getAttribute('aria-required') === 'true' ? 'required' : 'optional'
        ].join(':')).sort();
        return `${getWrapperTitle(wrapper)}|${identifiers.join(',')}`;
      }).filter(Boolean).sort();
      return selectionChecksum(schemaPairs);
    };

    const privatePropertyNames = {
      customization: '_fd_customization',
      base: '_fd_base_price_cents',
      addon: '_fd_addon_cents',
      configured: '_fd_configured_unit_cents',
      currency: '_fd_currency',
      checksum: '_fd_selection_checksum',
      state: '_fd_price_state',
      guardVersion: '_fd_price_guard_version',
      colorAdjustment: '_fd_color_adjustment_cents'
    };

    const setPrivateProperty = (key, value) => {
      if (!form) return;
      const propertyName = privatePropertyNames[key];
      let input = form.querySelector(`input[data-fd-private-price="${propertyName}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${propertyName}]`;
        input.setAttribute('data-fd-private-price', propertyName);
        form.appendChild(input);
      }
      input.value = String(value == null ? '' : value);
    };

    const syncPrivateProperties = (snapshot) => {
      if (!isCustomizable || !snapshot) return;
      setPrivateProperty('customization', '1');
      setPrivateProperty('base', snapshot.baseCents);
      setPrivateProperty('addon', snapshot.addOnCents == null ? '' : snapshot.addOnCents);
      setPrivateProperty('configured', snapshot.configuredUnitCents == null ? '' : snapshot.configuredUnitCents);
      setPrivateProperty('currency', currency);
      setPrivateProperty('checksum', snapshot.selectionChecksum || '');
      setPrivateProperty('state', snapshot.state);
      if (snapshot.colorGuardRequired) {
        const guardReady = snapshot.state === 'ready'
          && snapshot.colorGuardValid
          && Number.isSafeInteger(snapshot.colorAdjustmentCents);
        setPrivateProperty('guardVersion', guardReady ? colorPriceGuardVersion : '');
        setPrivateProperty('colorAdjustment', guardReady ? snapshot.colorAdjustmentCents : '');
      }
    };

    const getFormError = () => {
      if (!form) return null;
      let error = form.querySelector('[data-fd-pdp-form-error]');
      if (!error) {
        error = document.createElement('p');
        error.setAttribute('data-fd-pdp-form-error', '');
        error.setAttribute('role', 'alert');
        error.style.color = '#8b2e24';
        error.style.fontSize = '13px';
        error.style.lineHeight = '1.45';
        error.style.margin = '8px 0';
        const submit = form.querySelector('[data-fd-atc]');
        form.insertBefore(error, submit || null);
      }
      return error;
    };

    const showFormError = (message) => {
      const error = getFormError();
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    };

    const clearFormError = () => {
      const error = form && form.querySelector('[data-fd-pdp-form-error]');
      if (error) error.hidden = true;
    };

    const setPriceText = (nodes, text) => nodes.forEach((node) => {
      if (node.textContent !== text) node.textContent = text;
    });

    const setPriceState = (state, baseCents, addOnCents, incompleteTitles = []) => {
      if (window.__fdNeutralPricing && window.__fdNeutralPricing.state === 'conflict') state = 'error';
      priceState = state;
      const quantity = Math.max(Number.parseInt(quantityInput ? quantityInput.value : '1', 10) || 1, 1);
      const configuredUnitCents = state === 'ready' ? baseCents + (addOnCents || 0) : null;
      const colorGuard = getGuardedColorReading();
      const selectionPairs = getOriginalSelectionPairs();
      const digest = selectionChecksum(selectionPairs);
      const variantId = variantInput ? String(variantInput.value || '') : '';
      const optionSchemaHash = getOptionSchemaHash();
      const materialSignature = JSON.stringify([
        state,
        variantId,
        baseCents,
        state === 'ready' ? (addOnCents || 0) : null,
        configuredUnitCents,
        quantity,
        currency,
        optionSchemaHash,
        digest,
        incompleteTitles,
        colorGuard.required,
        colorGuard.selected,
        colorGuard.valid,
        colorGuard.cents
      ]);
      lastObservedSelectionSignature = getObservedConfigurationSignature(selectionPairs);
      if (materialSignature === lastSnapshotMaterialSignature && latestSnapshot) {
        enforcePurchaseButtonState();
        return latestSnapshot;
      }
      lastSnapshotMaterialSignature = materialSignature;
      snapshotRevision += 1;
      latestSnapshot = {
        version: 1,
        state,
        variantId,
        basePriceCents: baseCents,
        addonCents: state === 'ready' ? (addOnCents || 0) : null,
        baseCents,
        addOnCents: state === 'ready' ? (addOnCents || 0) : null,
        configuredUnitCents,
        quantity,
        lineTotalCents: configuredUnitCents == null ? null : configuredUnitCents * quantity,
        currency,
        optionSchemaHash,
        selectionDigest: digest,
        selectionChecksum: digest,
        revision: snapshotRevision,
        serverQuoteStatus: 'unavailable',
        serverQuoteId: null,
        serverQuoteExpiresAt: null,
        selections: selectionPairs,
        incompleteTitles,
        colorGuardRequired: colorGuard.required,
        colorGuardSelected: colorGuard.selected,
        colorGuardValid: colorGuard.valid,
        colorAdjustmentCents: colorGuard.cents,
        priceGuardVersion: colorGuard.required ? colorPriceGuardVersion : ''
      };

      root.dataset.fdPriceState = state;
      root.dataset.fdBasePriceCents = String(baseCents);
      root.dataset.fdAddOnCents = addOnCents == null ? '' : String(addOnCents);
      root.dataset.fdConfiguredUnitCents = configuredUnitCents == null ? '' : String(configuredUnitCents);
      root.dataset.fdPriceGuardVersion = colorGuard.required ? colorPriceGuardVersion : '';
      root.dataset.fdColorAdjustmentCents = Number.isSafeInteger(colorGuard.cents)
        ? String(colorGuard.cents)
        : '';
      const primaryLabel = !isCustomizable
        ? 'Price'
        : state === 'ready'
          ? 'Configured total'
          : state === 'error'
            ? 'Price unavailable'
            : 'Starting at';
      setPriceText(primaryPriceLabels, primaryLabel);
      primaryPriceLabels.forEach((node) => {
        node.hidden = !isCustomizable;
      });
      primaryPriceWraps.forEach((node) => {
        node.setAttribute('aria-label', primaryLabel);
      });

      const baseFormatted = formatConfiguredPrice(baseCents);
      const addOnFormatted = formatConfiguredPrice(addOnCents || 0);
      const configuredFormatted = configuredUnitCents == null
        ? (isCustomizable && startingAddOnCents > 0 ? formatConfiguredPrice(baseCents + startingAddOnCents) : baseFormatted)
        : formatConfiguredPrice(configuredUnitCents);
      const lineFormatted = configuredUnitCents == null ? baseFormatted : formatConfiguredPrice(configuredUnitCents * quantity);

      // FD_BCPO_LAZY_PRICE_20261016: while options load, show the product's own starting price instead of a placeholder.
      setPriceText(primaryPriceNodes, state === 'error' ? '—' : configuredFormatted);
      setPriceText(configuredPriceNodes, state === 'error' ? 'Unavailable' : state === 'loading' ? 'Calculating…' : configuredFormatted);
      setPriceText(addOnPriceNodes, state === 'ready' ? addOnFormatted : '—');
      setPriceText(lineTotalNodes, state === 'error' ? 'Unavailable' : state === 'loading' ? 'Calculating…' : lineFormatted);
      setPriceText(orderQuantityNodes, String(quantity));

      enforcePurchaseButtonState();

      if (state === 'ready' && (addOnCents || 0) > 0) {
        comparePriceNodes.forEach((node) => { node.hidden = true; });
        savingsNodes.forEach((node) => { node.hidden = true; });
      } else {
        updateSavings();
      }

      if (state !== 'error') clearFormError();
      syncPrivateProperties(latestSnapshot);
      window.FDConfiguredPrice = latestSnapshot;
      root.dispatchEvent(new CustomEvent('fd:configured-price', {
        bubbles: true,
        detail: latestSnapshot
      }));
    };

    const observeMutationTarget = (observer, target, options) => {
      if (!observer || !target || target.nodeType !== 1) return false;
      try {
        observer.observe(target, options);
        return true;
      } catch (error) {
        return false;
      }
    };

    const setPurchaseButtonLabel = (button, label) => {
      if (!button || !label || purchaseTransportBusy) return;
      if (button.matches('input')) {
        if (String(button.value || '').trim() !== label) button.value = label;
        return;
      }
      const isPrimaryPurchaseButton = button.matches(
        '[data-fd-atc], .fd-pdp-form button[name="add"], .fd-pdp-form button[type="submit"]'
      );
      let labelNode = isPrimaryPurchaseButton
        ? button.querySelector('[data-fd-atc-text]')
        : button;
      if (!labelNode && isPrimaryPurchaseButton) {
        labelNode = document.createElement('span');
        labelNode.setAttribute('data-fd-atc-text', '');
        button.replaceChildren(labelNode);
      }
      if (!labelNode) return;
      const currentLabel = String(labelNode.textContent || '').trim();
      if (currentLabel !== label) labelNode.textContent = label;
    };

    const isPurchaseButtonBusy = (button) => {
      if (purchaseTransportBusy || !button) return true;
      const hasBusyFlag = button.getAttribute('aria-busy') === 'true'
        || button.classList.contains('is-loading')
        || button.dataset.loading === 'true';
      const currentLabel = button.matches('input')
        ? String(button.value || '').trim()
        : String(button.textContent || '').trim();
      return hasBusyFlag && /^(?:Adding(?:\.{3}|…)?|Added)$/i.test(currentLabel);
    };

    const bindPurchaseButtonObservers = () => {
      const nextButtons = queryPurchaseButtons();
      const buttonsChanged = nextButtons.length !== purchaseButtons.length
        || nextButtons.some((button, index) => button !== purchaseButtons[index]);
      if (!buttonsChanged && purchaseButtonObserver) return;

      if (purchaseButtonObserver) purchaseButtonObserver.disconnect();
      purchaseButtons = nextButtons;
      if (!purchaseButtons.length) {
        purchaseButtonObserver = null;
        return;
      }

      purchaseButtonObserver = new MutationObserver((records) => {
        if (records.some((record) => (
          (record.type === 'attributes'
            && (record.attributeName === 'disabled' || record.attributeName === 'aria-disabled'))
          || record.type === 'childList'
          || record.type === 'characterData'
        ))) {
          enforcePurchaseButtonState();
        }
      });
      purchaseButtons.forEach((button) => {
        observeMutationTarget(purchaseButtonObserver, button, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          characterData: true,
          subtree: true
        });
      });
    };

    const enforcePurchaseButtonState = () => {
      bindPurchaseButtonObservers();
      syncPreviewPurchaseNotice(root);
      const variant = getCurrentVariant();
      const stockAvailable = isCustomizable || !variant || variant.available !== false;
      const priceGateReady = (!usesConfiguredPurchaseGate(root) || priceState === 'ready') && (!usesSemanticRequiredCache || (
        root.dataset.fdConditionalState === 'clean'
        && priceState === 'ready'
        && headrailNeutralClean(root)
          && roman001ConstraintsClean(root) && roman015ConstraintsClean(root)
        && roman056ConstraintsClean(root)
          && roman014ConstraintsClean(root)
      ));
      const shouldDisable = !stockAvailable || !priceGateReady;
      const buttonLabel = purchasePriceLabel(root, stockAvailable ? 'Add to Cart' : 'Sold Out');
      purchaseButtons.forEach((button) => {
        if (enforcePreviewOnlyPurchaseButton(root, button)) return;
        if (!priceGateReady) {
          if (!button.disabled) button.disabled = true;
          if (button.getAttribute('aria-disabled') !== 'true') {
            button.setAttribute('aria-disabled', 'true');
          }
          button.dataset.fdPriceLock = 'true';
          if (!isPurchaseButtonBusy(button)) setPurchaseButtonLabel(button, buttonLabel);
          return;
        }
        if (isPurchaseButtonBusy(button)) return;
        if (shouldDisable) {
          if (!button.disabled) button.disabled = true;
          if (button.dataset.fdPriceLock === 'true') delete button.dataset.fdPriceLock;
          if (button.getAttribute('aria-disabled') !== 'true') {
            button.setAttribute('aria-disabled', 'true');
          }
          setPurchaseButtonLabel(button, buttonLabel);
          return;
        }
        if (button.dataset.fdPriceLock === 'true') delete button.dataset.fdPriceLock;
        if (button.disabled) button.disabled = false;
        if (button.getAttribute('aria-disabled') !== 'false') {
          button.setAttribute('aria-disabled', 'false');
        }
        setPurchaseButtonLabel(button, buttonLabel);
      });
    };

    const requestStableConfirmation = (delay = stableReadIntervalMs) => {
      if (confirmationFrame) return;
      const requestedGeneration = selectionGeneration;
      const confirm = () => {
        confirmationFrame = 0;
        if (requestedGeneration !== selectionGeneration) return;
        updateConfiguredPrice();
      };
      confirmationFrame = window.setTimeout(confirm, Math.max(Number(delay) || 0, 20));
    };

    const markSelectionChange = (selectionSignature = getObservedConfigurationSignature()) => {
      const now = Date.now();
      selectionGeneration += 1;
      pendingSelectionSignature = selectionSignature;
      lastStableSelectionSignature = '';
      stableSelectionReads = 0;
      selectionChangedAt = now;
      confirmationNotBefore = now + selectionSettleMs;
      priceConfirmationDeadline = now + priceConfirmationTimeoutMs;
    };

    const acknowledgeAddOnMutation = (confirmsCurrentSelection = false) => {
      if (confirmsCurrentSelection) {
        priceMutationConfirmedGeneration = Math.max(
          priceMutationConfirmedGeneration,
          selectionGeneration
        );
      }
      confirmationNotBefore = Math.max(confirmationNotBefore, Date.now() + mutationQuietMs);
    };

    const updateConfiguredPrice = () => {
      const bcpoRoot = getBcpoRoot();
      const variant = getCurrentVariant();
      const baseCents = variant && Number.isSafeInteger(Number(variant.price)) && Number(variant.price) >= 0
        ? Number(variant.price)
        : null;
      if (baseCents === null) {
        if (isCustomizable) {
          setPriceState('error', 0, null);
          showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
        }
        return;
      }
      if (isRoman014 && root.dataset.fd014ConstraintState==='needs_review') {
        setPriceState('incomplete',baseCents,null,['No-drill installation confirmation']);
        showFormError('No-drill installation for this height needs confirmation. Choose standard installation or contact us before ordering.');
        return;
      }
      if (isRoman014 && !isCustomizable) {setPriceState('error',baseCents,null);return;}
      if (isRoman056 && !isCustomizable) {
        setPriceState('error', baseCents, null);
        return;
      }
      if (isRoman001 && !isCustomizable) {
        setPriceState('error', baseCents, null);
        return;
      }
      if (isRoman015 && !isCustomizable) {
        setPriceState('error', baseCents, null);
        return;
      }
      if (!isCustomizable) {
        setPriceState('ready', baseCents, 0);
        return;
      }

      if (!bcpoRoot) {
        setPriceState(bcpoMissingFinal ? 'error' : 'loading', baseCents, null);
        if (bcpoMissingFinal) {
          showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
        }
        return;
      }

      const colorGuard = getGuardedColorReading();
      if (colorGuard.required && !colorGuard.selected) {
        setPriceState('incomplete', baseCents, null, ['Color']);
        return;
      }
      if (
        colorGuard.required
        && (!colorGuard.valid || !Number.isSafeInteger(colorGuard.cents))
      ) {
        setPriceState('error', baseCents, null);
        showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
        return;
      }
      const requiredSnapshot = getRequiredValidationSnapshot();
      const incompleteTitles = requiredSnapshot.titles;
      const mappingBlocked = requiredSnapshot.mappingBlocked
        || root.dataset.fdVoMappingError === 'true';
      if (requiredSnapshot.priceError) {
        setPriceState('error', baseCents, null);
        showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
        return;
      }
      if (!requiredSnapshot.ready && !mappingBlocked) {
        setPriceState('loading', baseCents, null);
        return;
      }
      if (incompleteTitles.length || mappingBlocked) {
        setPriceState('incomplete', baseCents, null, incompleteTitles);
        return;
      }

      const addOnReading = getBcpoAddOnReading();
      if (!addOnReading.ready) {
        if (Date.now() >= priceConfirmationDeadline) {
          setPriceState('error', baseCents, null);
          showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
          return;
        }
        setPriceState('loading', baseCents, null);
        requestStableConfirmation(Math.max(priceConfirmationDeadline - Date.now(), 20));
        return;
      }

      if (priceMutationConfirmedGeneration < selectionGeneration) {
        const now = Date.now();
        const currentSelectionSignature = getObservedConfigurationSignature();
        if (currentSelectionSignature !== pendingSelectionSignature) {
          pendingSelectionSignature = currentSelectionSignature;
          lastObservedSelectionSignature = currentSelectionSignature;
          lastStableSelectionSignature = '';
          stableSelectionReads = 0;
          selectionChangedAt = now;
          confirmationNotBefore = Math.max(confirmationNotBefore, now + selectionSettleMs);
        }
        if (currentSelectionSignature === lastStableSelectionSignature) {
          stableSelectionReads += 1;
        } else {
          lastStableSelectionSignature = currentSelectionSignature;
          stableSelectionReads = 1;
        }

        const unchangedPriceReadyAt = Math.max(
          confirmationNotBefore,
          selectionChangedAt + unchangedPriceConfirmationMs
        );
        const stableReadbackConfirmed = Boolean(currentSelectionSignature)
          && currentSelectionSignature === pendingSelectionSignature
          && stableSelectionReads >= 2
          && now >= unchangedPriceReadyAt;

        if (stableReadbackConfirmed) {
          // A BCPO selection may legitimately keep the same add-on amount.
          // Confirm that path from stable control readback plus two stable
          // add-on reads instead of requiring a price-text mutation.
          priceMutationConfirmedGeneration = selectionGeneration;
        } else if (now >= priceConfirmationDeadline) {
          setPriceState('error', baseCents, null);
          showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
          return;
        } else {
          setPriceState('loading', baseCents, null);
          const nextReadDelay = now < unchangedPriceReadyAt
            ? Math.min(Math.max(unchangedPriceReadyAt - now, stableReadIntervalMs), 600)
            : stableReadIntervalMs;
          requestStableConfirmation(nextReadDelay);
          return;
        }
      }

      const remainingSettleMs = confirmationNotBefore - Date.now();
      if (remainingSettleMs > 0) {
        setPriceState('loading', baseCents, null);
        requestStableConfirmation(remainingSettleMs);
        return;
      }

      if (addOnReading.signature === lastAddOnSignature) stableAddOnReads += 1;
      else {
        lastAddOnSignature = addOnReading.signature;
        stableAddOnReads = 1;
      }
      if (stableAddOnReads < 2) {
        setPriceState('loading', baseCents, null);
        requestStableConfirmation();
        return;
      }
      if (baseCents + addOnReading.cents < 0) {
        setPriceState('error', baseCents, null);
        showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
        return;
      }
      if (isHeadrailNeutralProduct(root)) {
        const integrity=readHeadrailNeutralPrice(root,{baseCents,addOnCents:addOnReading.cents,currency});
        root.dataset.fdHeadrailPriceIntegrity=integrity.ready?'matched':integrity.reason||'pending';
        if(!integrity.ready){
          if(integrity.incomplete){const names=(integrity.pure?.missing_required||[]).map(key=>root.querySelector('#bcpo [data-unique="'+key+'"]')).filter(Boolean).map(getWrapperTitle);setPriceState('incomplete',baseCents,null,names);}
          else if(integrity.error||Date.now()>=priceConfirmationDeadline){setPriceState('error',baseCents,null);showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');}
          else {setPriceState('loading',baseCents,null);requestStableConfirmation(60);}
          return;
        }
      }
      if (isRoman001) {
        const integrity = readRoman001PriceIntegrity(root, {baseCents,addOnCents:addOnReading.cents,currency});
        root.dataset.fd001PriceIntegrity = integrity.ready ? 'matched' : integrity.reason || 'pending';
        if (!integrity.ready) {
          if (integrity.incomplete) {
            const names=(integrity.pure?.missing_required || []).map(key=>root.querySelector('#bcpo [data-unique="'+key+'"]')).filter(Boolean).map(getWrapperTitle);
            setPriceState('incomplete',baseCents,null,names);
          } else if (integrity.error || Date.now() >= priceConfirmationDeadline) {
            setPriceState('error',baseCents,null);
            showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
          } else {
            setPriceState('loading',baseCents,null);
            requestStableConfirmation(60);
          }
          return;
        }
      }
      if (isRoman015) {
        const integrity = readRoman015PriceIntegrity(root, {baseCents,addOnCents:addOnReading.cents,currency});
        root.dataset.fd015PriceIntegrity = integrity.ready ? 'matched' : integrity.reason || 'pending';
        if (!integrity.ready) {
          if (integrity.incomplete) {
            const names=(integrity.pure?.missing_required || []).map(key=>root.querySelector('#bcpo [data-unique="'+key+'"]')).filter(Boolean).map(getWrapperTitle);
            setPriceState('incomplete',baseCents,null,names);
          } else if (integrity.error || Date.now() >= priceConfirmationDeadline) {
            setPriceState('error',baseCents,null);
            showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
          } else {
            setPriceState('loading',baseCents,null);
            requestStableConfirmation(60);
          }
          return;
        }
      }
      if (isRoman056) {
        const integrity = readRoman056PriceIntegrity(root, {baseCents,addOnCents:addOnReading.cents,currency});
        root.dataset.fd056PriceIntegrity = integrity.ready ? 'matched' : integrity.reason || 'pending';
        if (!integrity.ready) {
          if (integrity.incomplete) {
            const names=(integrity.pure?.missing_required || []).map(key=>root.querySelector('#bcpo [data-unique="'+key+'"]')).filter(Boolean).map(getWrapperTitle);
            setPriceState('incomplete',baseCents,null,names);
          } else if (integrity.error || Date.now() >= priceConfirmationDeadline) {
            setPriceState('error',baseCents,null);
            showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
          } else {
            setPriceState('loading',baseCents,null);
            requestStableConfirmation(60);
          }
          return;
        }
      }
      if (isRoman014) {
        const integrity = readRoman014PriceIntegrity(root, {baseCents,addOnCents:addOnReading.cents,currency});
        root.dataset.fd014PriceIntegrity = integrity.ready ? 'matched' : integrity.reason || 'pending';
        if (!integrity.ready) {
          if (integrity.incomplete) {
            const names=(integrity.pure?.missing_required || []).map(key=>root.querySelector('#bcpo [data-unique="'+key+'"]')).filter(Boolean).map(getWrapperTitle);
            setPriceState('incomplete',baseCents,null,names);
          } else if (integrity.error || Date.now() >= priceConfirmationDeadline) {
            setPriceState('error',baseCents,null);
            showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
          } else {
            setPriceState('loading',baseCents,null);
            requestStableConfirmation(60);
          }
          return;
        }
      }
      setPriceState('ready', baseCents, addOnReading.cents);
    };

    const enforceForceHiddenBcpoFields = () => {
      root.querySelectorAll('#bcpo .fd-bcpo-force-hidden').forEach((wrapper) => {
        if (wrapper.dataset.fdVoSyncConfirmed !== 'true') {
          wrapper.classList.remove('fd-bcpo-force-hidden');
          wrapper.hidden = false;
          wrapper.removeAttribute('aria-hidden');
          wrapper.style.removeProperty('display');
          return;
        }
        if (!wrapper.hidden) wrapper.hidden = true;
        if (wrapper.getAttribute('aria-hidden') !== 'true') wrapper.setAttribute('aria-hidden', 'true');
        if (wrapper.style.getPropertyValue('display') !== 'none' || wrapper.style.getPropertyPriority('display') !== 'important') {
          wrapper.style.setProperty('display', 'none', 'important');
        }
      });
    };

    const enforceConfigurationOrder = () => {
      const ordered = [
        ['#bcpo', 10],
        ['.fd-pdp-custom', 20],
        ['.fd-pdp-included-support', 30],
        ['.fd-pdp-qty-row', 40],
        ['.fd-pdp-order-total', 50],
        ['[data-fd-pdp-form-error]', 55],
        ['.fd-pdp-atc', 60],
        ['.fd-pdp-cta-support', 70],
        ['.fd-pdp-policy-preview', 80],
        ['.fd-pdp-payments', 90]
      ];
      ordered.forEach(([selector, order]) => {
        const node = form && Array.from(form.children).find((child) => child.matches && child.matches(selector));
        if (!node) return;
        const value = String(order);
        if (node.style.getPropertyValue('order') !== value || node.style.getPropertyPriority('order') !== 'important') {
          node.style.setProperty('order', value, 'important');
        }
      });
    };

    const compactColorOptions = () => {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
      const visibleLimit = isMobile ? 9 : 12;
      root.querySelectorAll('#bcpo .fd-bcpo-color-option, [data-fd-template-color-field]').forEach((wrapper) => {
        const choices = Array.from(wrapper.querySelectorAll('.fd-bcpo-color-choice, [data-fd-template-bcpo-color]'));
        let button = wrapper.querySelector('[data-fd-p0-color-expand]');

        if (choices.length <= visibleLimit) {
          choices.forEach((choice) => {
            choice.removeAttribute('data-fd-p0-color-collapsed');
            choice.style.removeProperty('display');
          });
          if (button) button.remove();
          return;
        }

        const expanded = wrapper.dataset.fdP0ColorsExpanded === 'true';
        choices.forEach((choice, index) => {
          const selected = choice.classList.contains('fd-bcpo-is-selected')
            || choice.classList.contains('is-selected')
            || choice.getAttribute('aria-pressed') === 'true'
            || Boolean(choice.querySelector('input:checked'));
          const collapsed = !expanded && index >= visibleLimit && !selected;
          choice.setAttribute('data-fd-p0-color-collapsed', collapsed ? 'true' : 'false');
          if (collapsed) choice.style.setProperty('display', 'none', 'important');
          else choice.style.removeProperty('display');
        });

        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'fd-p0-color-expand';
          button.setAttribute('data-fd-p0-color-expand', '');
          wrapper.appendChild(button);
        }
        const buttonLabel = expanded ? 'Show fewer colors' : `Show all ${choices.length} colors`;
        if (button.textContent !== buttonLabel) button.textContent = buttonLabel;
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    };

    const normalizeCustomerFacingTypos = () => {
      root.querySelectorAll('[data-fd-vo-template] option').forEach((option) => {
        if (option.textContent && option.textContent.includes('Whtie')) {
          option.textContent = option.textContent.replace(/Whtie/g, 'White');
        }
      });
    };

    const installMobileChatPolish = () => {
      if (!root.classList.contains('fd-pdp--roman-ad')) return true;
      const chatAgent = document.querySelector('shopify-agent');
      const shadowRoot = chatAgent && chatAgent.shadowRoot;
      if (!chatAgent || !shadowRoot) return false;

      if (!shadowRoot.querySelector('[data-fd-pdp-chat-polish]')) {
        const style = document.createElement('style');
        style.setAttribute('data-fd-pdp-chat-polish', '');
        style.textContent = `
          @media (max-width: 749px) {
            :host([data-fd-pdp-chat-ready="false"]) .activator-nudge {
              visibility: hidden !important;
              opacity: 0 !important;
              pointer-events: none !important;
              transform: translateY(14px) !important;
            }

            .activator-nudge {
              right: 8px !important;
              bottom: 8px !important;
              width: 48px !important;
              min-width: 48px !important;
              max-width: 48px !important;
              transition: opacity .18s ease, transform .18s ease, visibility .18s ease !important;
            }

            .activator {
              width: 48px !important;
              min-width: 48px !important;
              max-width: 48px !important;
              height: 48px !important;
              min-height: 48px !important;
              max-height: 48px !important;
              padding: 0 !important;
              border-radius: 50% !important;
              grid-template-columns: 1fr !important;
              gap: 0 !important;
              justify-items: center !important;
              overflow: hidden !important;
            }

            .activator__label,
            .activator__indicator {
              display: none !important;
            }
          }
        `;
        shadowRoot.appendChild(style);
      }

      const syncChatVisibility = () => {
        const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
        const isPastFirstView = window.scrollY > 180;
        chatAgent.setAttribute('data-fd-pdp-chat-ready', !isMobile || isPastFirstView ? 'true' : 'false');
      };

      if (chatAgent.getAttribute('data-fd-pdp-chat-bound') !== 'true') {
        chatAgent.setAttribute('data-fd-pdp-chat-bound', 'true');
        window.addEventListener('scroll', syncChatVisibility, { passive: true });
        window.addEventListener('resize', syncChatVisibility, { passive: true });
      }
      syncChatVisibility();
      return true;
    };

    const flushPrice = () => {
      updateBasePrice();
      updateSavings();
      updateConfiguredPrice();
    };

    let priceFrame = 0;
    const scheduleUpdate = (resetStability = false) => {
      if (resetStability) {
        lastAddOnSignature = '';
        stableAddOnReads = 0;
        if (confirmationFrame) {
          window.clearTimeout(confirmationFrame);
          confirmationFrame = 0;
        }
      }
      if (priceFrame) return;
      const flush = () => {
        priceFrame = 0;
        flushPrice();
      };
      priceFrame = window.setTimeout(flush, 0);
    };

    let observedAddOnNode = null;
    let addOnObserver = null;
    let lastObservedAddOnMutationSignature = '';
    const markObservedAddOnPriceMissing = () => {
      if (addOnObserver) addOnObserver.disconnect();
      addOnObserver = null;
      observedAddOnNode = null;
      if (lastObservedAddOnMutationSignature === 'missing') {
        scheduleUpdate(false);
        return;
      }
      lastObservedAddOnMutationSignature = 'missing';
      acknowledgeAddOnMutation();
      scheduleUpdate(true);
    };
    const scheduleObservedAddOnPriceUpdate = (confirmsCurrentSelection = false) => {
      const reading = getBcpoAddOnReading();
      const priceMateriallyChanged = reading.signature !== lastObservedAddOnMutationSignature;
      const pendingSelectionNeedsConfirmation = confirmsCurrentSelection
        && priceMutationConfirmedGeneration < selectionGeneration;
      if (!priceMateriallyChanged && !pendingSelectionNeedsConfirmation) return false;
      invalidateSemanticRequiredValues();
      lastObservedAddOnMutationSignature = reading.signature;
      acknowledgeAddOnMutation(pendingSelectionNeedsConfirmation);
      scheduleUpdate(true);
      return true;
    };
    const bindHeadrailAddonEvent = () => {
      if(!isHeadrailNeutralProduct(root)||headrailAddonBridgeBound||typeof window.bcpo?.$!=='function')return;
      window.bcpo.$(document).on('bcpo:addonChange.fdHeadrailPrice',(_event,origin,_formatted,total)=>{
        if(origin?.target&&!root.contains(origin.target))return;
        const variant=getCurrentVariant(),base=Number(variant?.price),raw=Number(total),unit=Math.round(raw);
        const expected=window.FDHeadrailNeutral20260910?.registries[String(root.dataset.productId)]?.nativeVariants[String(variant?.id)];
        if(expected!==base||!Number.isSafeInteger(unit)||Math.abs(raw-unit)>0.000001||unit<base){headrailAddonReading={invalid:true};root.dataset.fdHeadrailBcpoPriceSource='invalid-addon-event';delete root.dataset.fdHeadrailBcpoEventUnitCents;scheduleObservedAddOnPriceUpdate(true);return;}
        headrailAddonReading={cents:unit-base,variantId:String(variant.id),signature:JSON.stringify(root.__fdHeadrailNeutral?.readSelections())};
        root.dataset.fdHeadrailBcpoPriceSource='addon-event';root.dataset.fdHeadrailBcpoEventUnitCents=String(unit);scheduleObservedAddOnPriceUpdate(true);
      });
      headrailAddonBridgeBound=true;
    };
    const bindFD50SeriesAddonEvent = () => {
  if(!(String(window.Shopify?.theme?.role).toLowerCase()==='unpublished'&&["9276036546810","9276036776186","9276032385274","9276037595386","9276038775034","9276038709498","9276037660922","9276035760378","9276032155898","9276031926522","9275984773370","9275977793786","9276033106170","9276033204474","9275982708986","9275984412922","9276038119674","9276033564922","9276037366010","9276038873338","9276037923066","9276037857530","9275982119162","9276035203322","9275985264890","9275980775674","9276037103866","9275975336186","9275974189306","9276038611194","9276033695994","9276034744570","9276035399930","9275979170042","9276034580730","9276038447354","9276032778490","9275972845818","9276036743418","9276035596538","9276032286970","9276032844026","9276032319738"].includes(String(root.dataset.productId)))||fd50SeriesAddonBridgeBound||typeof window.bcpo?.$!=='function')return;
  window.bcpo.$(document).on('bcpo:addonChange.fd50SeriesPrice',(_event,origin,_formatted,total)=>{
    if(origin?.target&&!root.contains(origin.target))return;
    const variant=getCurrentVariant(),base=Number(variant?.price),raw=Number(total),unit=Math.round(raw);
    if(!variant||String(variant.id)!==String(root.querySelector('[data-fd-variant-id]')?.value)||!Number.isSafeInteger(base)||!Number.isSafeInteger(unit)||Math.abs(raw-unit)>0.000001||unit<base){fd50SeriesAddonReading={invalid:true};root.dataset.fd50BcpoPriceSource='invalid-addon-event';delete root.dataset.fd50BcpoEventUnitCents;scheduleObservedAddOnPriceUpdate(true);return;}
    fd50SeriesAddonReading={cents:unit-base,variantId:String(variant.id),signature:getObservedConfigurationSignature()};
    root.dataset.fd50BcpoPriceSource='addon-event';root.dataset.fd50BcpoEventUnitCents=String(unit);scheduleObservedAddOnPriceUpdate(true);
  });fd50SeriesAddonBridgeBound=true;
 };
    const bindRoman001AddonEvent = () => {
      if(!isRoman001||roman001AddonBridgeBound||typeof window.bcpo?.$!=='function')return;
      window.bcpo.$(document).on('bcpo:addonChange.fdRoman001Price',(_event,origin,_formatted,total)=>{
        if(origin?.target&&!root.contains(origin.target))return;
        const variant=getCurrentVariant(),base=Number(variant?.price),raw=Number(total),unit=Math.round(raw);
        // Native BCPO sums decimal dollar prices in JS; accept only float noise below a millionth of a cent.
        const exact=window.FDRoman001Source20260910?.candidate.pricing.variants;
        const expected=exact&&Object.values(exact).find(v=>String(v.id)===String(variant?.id));
        if(!expected||Math.round(Number(expected.base_usd)*100)!==base||!Number.isSafeInteger(unit)||Math.abs(raw-unit)>0.000001||unit<base){
          roman001AddonReading={invalid:true};root.dataset.fd001BcpoPriceSource='invalid-addon-event';delete root.dataset.fd001BcpoEventUnitCents;scheduleObservedAddOnPriceUpdate(true);return;
        }
        roman001AddonReading={cents:unit-base,variantId:String(variant.id),signature:getObservedConfigurationSignature()};
        root.dataset.fd001BcpoPriceSource='addon-event';root.dataset.fd001BcpoEventUnitCents=String(unit);
        scheduleObservedAddOnPriceUpdate(true);
      });
      roman001AddonBridgeBound=true;
    };
    const bindRoman014AddonEvent = () => {
      if(!isRoman014||roman014AddonBridgeBound||typeof window.bcpo?.$!=='function')return;
      window.bcpo.$(document).on('bcpo:addonChange.fdRoman014Price',(_event,origin,_formatted,total)=>{
        if(origin?.target&&!root.contains(origin.target))return;
        const variant=getCurrentVariant(),base=Number(variant?.price),unit=Number(total);
        if(!Number.isSafeInteger(unit)||unit<base||base!==5499){roman014AddonReading={invalid:true};root.dataset.fd014BcpoPriceSource='invalid-addon-event';delete root.dataset.fd014BcpoEventUnitCents;scheduleObservedAddOnPriceUpdate(true);return;}
        roman014AddonReading={cents:unit-base,variantId:String(variant.id),signature:getObservedConfigurationSignature()};
        root.dataset.fd014BcpoPriceSource='addon-event';root.dataset.fd014BcpoEventUnitCents=String(unit);
        scheduleObservedAddOnPriceUpdate(true);
      });
      roman014AddonBridgeBound=true;
    };
    const observeBcpoAddOnPrice = () => {
      bindHeadrailAddonEvent();
      if(isHeadrailNeutralProduct(root)){const legacyNotice=root.querySelector('.bcpo-price-addons');if(legacyNotice){legacyNotice.hidden=true;legacyNotice.style.display='none';legacyNotice.setAttribute('aria-hidden','true');}}
      bindFD50SeriesAddonEvent();
      bindRoman001AddonEvent();
      if(isRoman001){const legacyNotice=root.querySelector('.bcpo-price-addons');if(legacyNotice){legacyNotice.hidden=true;legacyNotice.style.display='none';legacyNotice.setAttribute('aria-hidden','true');}}
      bindRoman014AddonEvent();
      if(isRoman014){const legacyNotice=root.querySelector('.bcpo-price-addons');if(legacyNotice){legacyNotice.hidden=true;legacyNotice.style.display='none';legacyNotice.setAttribute('aria-hidden','true');}}
      const addOnNode = root.querySelector('.bcpo-addons-price') || document.querySelector('.bcpo-addons-price');
      if (!addOnNode) {
        markObservedAddOnPriceMissing();
        return;
      }
      if (addOnNode === observedAddOnNode) return;
      if (addOnObserver) addOnObserver.disconnect();
      observedAddOnNode = addOnNode;
      addOnObserver = new MutationObserver((records) => {
        if (records.length && !scheduleObservedAddOnPriceUpdate(true)) scheduleUpdate(false);
      });
      observeMutationTarget(addOnObserver, addOnNode, { childList: true, subtree: true, characterData: true });
      if (!scheduleObservedAddOnPriceUpdate(true)) scheduleUpdate(false);
    };

    const runPolicyCleanup = () => {
      enforceForceHiddenBcpoFields();
      enforceConfigurationOrder();
      compactColorOptions();
      normalizeCustomerFacingTypos();
    };

    let cleanupFrame = 0;
    const schedulePolicyCleanup = () => {
      if (cleanupFrame) return;
      const cleanup = () => {
        cleanupFrame = 0;
        runPolicyCleanup();
      };
      if (window.requestAnimationFrame) {
        cleanupFrame = window.requestAnimationFrame(cleanup);
      } else {
        cleanupFrame = window.setTimeout(cleanup, 0);
      }
    };

    const nodeMatchesOrContains = (node, selector) => {
      const element = node && node.nodeType === 1 ? node : node && node.parentElement;
      if (!element) return false;
      return Boolean(
        (element.matches && element.matches(selector))
        || (element.closest && element.closest(selector))
        || (element.querySelector && element.querySelector(selector))
      );
    };

    const mutationNodesMatch = (record, selector) => {
      if (!record || record.type !== 'childList') return false;
      return Array.from(record.addedNodes || [])
        .concat(Array.from(record.removedNodes || []))
        .some((node) => nodeMatchesOrContains(node, selector));
    };

    const mutationMountsOrRemoves = (record, selector) => {
      if (!record || record.type !== 'childList') return false;
      return Array.from(record.addedNodes || [])
        .concat(Array.from(record.removedNodes || []))
        .some((node) => {
          const element = node && node.nodeType === 1 ? node : null;
          if (!element) return false;
          return Boolean(
            (element.matches && element.matches(selector))
            || (element.querySelector && element.querySelector(selector))
          );
        });
    };

    const forceHiddenNeedsRepair = (record) => {
      if (!record || record.type !== 'attributes') return false;
      const node = record.target && record.target.closest
        ? record.target.closest('#bcpo .fd-bcpo-force-hidden')
        : null;
      if (!node) return false;
      return !node.hidden
        || node.getAttribute('aria-hidden') !== 'true'
        || node.style.getPropertyValue('display') !== 'none'
        || node.style.getPropertyPriority('display') !== 'important';
    };

    let observedBcpoRoot = null;
    let bcpoObserver = null;
    const legacyBcpoStateAttributes = [
      'class',
      'style',
      'hidden',
      'aria-hidden',
      'disabled',
      'required',
      'aria-required'
    ];
    const observedBcpoStateAttributes = usesSemanticRequiredCache
      ? legacyBcpoStateAttributes.concat([
        'name',
        'type',
        'value',
        'checked',
        'data-fd-vo-sync-confirmed',
        'data-fd-vo-unavailable',
        'data-fd-required-active',
        'data-fd-bcpo-trim-bridge-confirmed'
      ])
      : legacyBcpoStateAttributes;
    const bindBcpoObserver = () => {
      const nextBcpoRoot = root.querySelector('#bcpo');
      if (nextBcpoRoot === observedBcpoRoot) {
        observeBcpoAddOnPrice();
        return Boolean(nextBcpoRoot);
      }

      if (bcpoObserver) bcpoObserver.disconnect();
      observedBcpoRoot = nextBcpoRoot || null;
      invalidateSemanticRequiredStructure();
      if (!observedBcpoRoot) return false;

      bcpoObserver = new MutationObserver((records) => {
        const structuralSelector = [
          '.selector-wrapper',
          '.bcpo-selector-wrapper',
          '.bold_option',
          '[data-option]',
          '.fd-bcpo-color-option',
          '[data-fd-template-color-field]',
          '.fd-bcpo-force-hidden',
          '[data-fd-vo-template]'
        ].join(', ');
        const structureChanged = records.some((record) => mutationNodesMatch(record, structuralSelector));
        const controlStructureChanged = usesSemanticRequiredCache && records.some((record) => (
          mutationNodesMatch(record, 'input, select, textarea')
          && nodeMatchesOrContains(record.target, requiredWrapperSelector)
        ));
        const optionStateChanged = records.some((record) => (
          record.type === 'attributes'
          && observedBcpoStateAttributes.includes(record.attributeName)
          && nodeMatchesOrContains(record.target, structuralSelector)
        ));
        const requiredMetadataChanged = usesSemanticRequiredCache && records.some((record) => (
          (record.type === 'characterData' || record.type === 'childList')
          && (
            nodeMatchesOrContains(record.target, requiredTitleSelector)
            || mutationNodesMatch(record, requiredTitleSelector)
          )
        ));
        const selectedColorChanged = records.some((record) => (
          record.type === 'attributes'
          && record.attributeName === 'class'
          && nodeMatchesOrContains(record.target, '.fd-bcpo-color-choice, [data-fd-template-bcpo-color]')
        ));
        const addOnPriceChanged = records.some((record) => (
          (record.type === 'characterData' || record.type === 'childList')
          && (
            nodeMatchesOrContains(record.target, '.bcpo-addons-price')
            || mutationNodesMatch(record, '.bcpo-addons-price')
          )
        ));

        if (usesSemanticRequiredCache) {
          if (structureChanged || controlStructureChanged) {
            invalidateSemanticRequiredStructure();
          } else if (optionStateChanged || requiredMetadataChanged) {
            records.forEach((record) => invalidateSemanticRequiredNode(record.target));
          }
        }
        if (structureChanged || controlStructureChanged || selectedColorChanged || records.some(forceHiddenNeedsRepair)) {
          schedulePolicyCleanup();
        }
        if (structureChanged || controlStructureChanged || optionStateChanged || requiredMetadataChanged) {
          observeBcpoAddOnPrice();
          scheduleUpdate(false);
        }
        if (addOnPriceChanged) {
          observeBcpoAddOnPrice();
          if (!scheduleObservedAddOnPriceUpdate(true)) scheduleUpdate(false);
        }
      });
      observeMutationTarget(bcpoObserver, observedBcpoRoot, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: observedBcpoStateAttributes
      });
      observeBcpoAddOnPrice();
      schedulePolicyCleanup();
      scheduleUpdate();
      return true;
    };

    const legacyRootObserverAttributes = ['data-fd-vo-mapping-error', 'data-fd-atc', 'name', 'type'];
    const observedRootStateAttributes = usesSemanticRequiredCache
      ? ['data-fd-vo-mapping-error', 'data-fd-product-twopages-livefix-ready', 'data-fd-native-bcpo-ready']
      : ['data-fd-vo-mapping-error'];
    const observedRootAttributes = usesSemanticRequiredCache
      ? legacyRootObserverAttributes.concat([
        'data-fd-product-twopages-livefix-ready',
        'data-fd-native-bcpo-ready',
        'data-fd-conditional-state',
        'data-fd-headrail-constraint-state', 'data-fd001-constraint-state', 'data-fd015-constraint-state',
        'data-fd056-constraint-state', 'data-fd014-constraint-state'
      ])
      : legacyRootObserverAttributes;
    let structureObserver = null;
    if (root) {
      structureObserver = new MutationObserver((records) => {
        const bcpoChanged = records.some((record) => mutationMountsOrRemoves(record, '#bcpo'));
        const purchaseControlsChanged = records.some((record) => mutationMountsOrRemoves(
          record,
          purchaseButtonSelector
        )) || records.some((record) => (
          record.type === 'attributes'
          && ['data-fd-atc', 'name', 'type'].includes(record.attributeName)
          && record.target
          && record.target.closest
          && Boolean(record.target.closest('.fd-pdp-form, [data-fd-sticky-atc]'))
        ));
        const mappingStateChanged = records.some((record) => (
          record.type === 'attributes'
          && record.target === root
          && observedRootStateAttributes.includes(record.attributeName)
        ));
        const conditionalStateChanged = usesSemanticRequiredCache && records.some((record) => (
          record.type === 'attributes'
          && record.target === root
          && ['data-fd-conditional-state', 'data-fd-headrail-constraint-state', 'data-fd001-constraint-state', 'data-fd015-constraint-state', 'data-fd056-constraint-state', 'data-fd014-constraint-state'].includes(record.attributeName)
        ));
        if (bcpoChanged) {
          invalidateSemanticRequiredStructure();
          bindBcpoObserver();
        }
        if (conditionalStateChanged) {
          invalidateSemanticRequiredValues();
          enforcePurchaseButtonState();
        }
        if (purchaseControlsChanged) {
          bindPurchaseButtonObservers();
          enforcePurchaseButtonState();
        }
        if (bcpoChanged || purchaseControlsChanged || mappingStateChanged) {
          schedulePolicyCleanup();
        }
        if (bcpoChanged || purchaseControlsChanged || mappingStateChanged || conditionalStateChanged) {
          scheduleUpdate();
        }
      });
      observeMutationTarget(structureObserver, root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: observedRootAttributes
      });
    }
    root.addEventListener('fd:conditional-state', () => {
      if (!usesSemanticRequiredCache) return;
      invalidateSemanticRequiredValues();
      enforcePurchaseButtonState();
      scheduleUpdate(false);
    });
    bindPurchaseButtonObservers();
    root.addEventListener('fd:purchase-transport', (event) => {
      purchaseTransportBusy = Boolean(event && event.detail && event.detail.busy);
      enforcePurchaseButtonState();
    });

    root.addEventListener('click', (event) => {
      const button = event.target && event.target.closest
        ? event.target.closest('[data-fd-p0-color-expand]')
        : null;
      if (!button || !root.contains(button)) return;
      const wrapper = button.closest('.fd-bcpo-color-option, [data-fd-template-color-field]');
      if (!wrapper) return;
      wrapper.dataset.fdP0ColorsExpanded = wrapper.dataset.fdP0ColorsExpanded === 'true' ? 'false' : 'true';
      compactColorOptions();
    }, true);
    const isRelevantConfigurationEvent = (event) => {
      const control = event.target && event.target.closest
        ? event.target.closest('input, select, textarea')
        : null;
      if (!control || !root.contains(control)) return false;

      // Quantity +/- controls commit by dispatching change; keep that narrow
      // synthetic path while direct number entry remains input-driven.
      if (control.matches('[data-fd-quantity]')) {
        return event.type === 'input' || (event.type === 'change' && event.isTrusted === false);
      }
      if (control.matches('[data-fd-variant-id]')) return event.type === 'change';
      if (control.tagName === 'SELECT') return event.type === 'change';
      if (control.tagName === 'TEXTAREA') return event.type === 'input';

      const inputType = String(control.type || 'text').toLowerCase();
      if (/^(radio|checkbox|file)$/.test(inputType)) return event.type === 'change';
      if (/^(text|number|search|tel|url|email)$/.test(inputType)) return event.type === 'input';
      return false;
    };

    const handleConfigurationEvent = (event) => {
      if (!isRelevantConfigurationEvent(event)) return;
      const target = event.target && event.target.closest
        ? event.target.closest('#bcpo, [data-fd-quantity], [data-fd-variant-id], .fd-pdp-qty-control')
        : null;
      if (!target || !root.contains(target)) return;
      const priceAffecting = Boolean(target.closest && target.closest('#bcpo, [data-fd-variant-id]'));
      if (priceAffecting && isCustomizable) {
        invalidateSemanticRequiredNode(event.target);
        const selectionSignature = getObservedConfigurationSignature();
        const selectionActuallyChanged = selectionSignature !== lastObservedSelectionSignature;
        if (selectionActuallyChanged) {
          lastObservedSelectionSignature = selectionSignature;
          markSelectionChange(selectionSignature);
          const variant = getCurrentVariant();
          const baseCents = variant && Number.isSafeInteger(Number(variant.price)) && Number(variant.price) >= 0
            ? Number(variant.price)
            : 0;
          // Publish loading immediately. The scheduled update reads the
          // semantic required-field snapshot after BCPO mutates its controls.
          const deferRequiredScan = usesSemanticRequiredCache;
          const incompleteTitles = deferRequiredScan ? [] : getIncompleteRequiredTitles();
          const mappingBlocked = root.dataset.fdVoMappingError === 'true';
          setPriceState(
            !variant ? 'error' : mappingBlocked || (!deferRequiredScan && incompleteTitles.length) ? 'incomplete' : 'loading',
            baseCents,
            null,
            incompleteTitles
          );
          scheduleUpdate(true);
        }
        if (target.closest && target.closest('#bcpo')) schedulePolicyCleanup();
        return;
      }
      scheduleUpdate(false);
      if (target.closest && target.closest('#bcpo')) schedulePolicyCleanup();
    };
    root.addEventListener('change', handleConfigurationEvent, true);
    root.addEventListener('input', handleConfigurationEvent, true);
    root.addEventListener('fd:variant-updated', () => {
      invalidateSemanticRequiredValues();
      markSelectionChange();
      lastAddOnSignature = '';
      stableAddOnReads = 0;
      if (confirmationFrame) {
        window.clearTimeout(confirmationFrame);
        confirmationFrame = 0;
      }
      updateBasePrice();
      updateSavings();
      updateConfiguredPrice();
      scheduleUpdate();
    });
    // All audited paid-option entries validate the current quote before BCPO serializes.
    const guardConfiguredPurchase = (event) => {
      if (!usesConfiguredPurchaseGate(root)) return true;
      const currentSignature = getObservedConfigurationSignature();
      if (currentSignature !== lastObservedSelectionSignature) {
        lastObservedSelectionSignature = currentSignature;
        markSelectionChange(currentSignature);
        stableAddOnReads = 0;
      }
      updateConfiguredPrice();
      const snapshot = latestSnapshot;
      const variant = getCurrentVariant();
      const quantity = Number(quantityInput ? quantityInput.value : 1);
      const conditionalReady = !usesSemanticRequiredCache || (
        root.dataset.fdConditionalState === 'clean'
        && headrailNeutralClean(root)
        && roman001ConstraintsClean(root) && roman015ConstraintsClean(root)
        && roman056ConstraintsClean(root) && roman014ConstraintsClean(root)
      );
      const quoteReady = conditionalReady && priceState === 'ready' && snapshot && snapshot.state === 'ready'
        && snapshot.variantId === String(variantInput && variantInput.value || '')
        && variant && snapshot.variantId === String(variant.id)
        && snapshot.currency === currency
        && Number.isSafeInteger(snapshot.baseCents) && snapshot.baseCents >= 0
        && snapshot.baseCents === Number(variant.price)
        && Number.isSafeInteger(snapshot.addOnCents) && snapshot.addOnCents >= 0
        && Number.isSafeInteger(snapshot.configuredUnitCents)
        && snapshot.configuredUnitCents === snapshot.baseCents + snapshot.addOnCents
        && Number.isSafeInteger(quantity) && quantity > 0 && snapshot.quantity === quantity
        && Number.isSafeInteger(snapshot.lineTotalCents)
        && snapshot.lineTotalCents === snapshot.configuredUnitCents * quantity
        && snapshot.selectionDigest === selectionChecksum(getOriginalSelectionPairs());
      if (quoteReady) {
        // Hidden amounts are integrity evidence; BCPO must still add public price suffixes.
        syncPrivateProperties(snapshot);
        return true;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      const message = priceState === 'error'
        ? 'Customization is temporarily unavailable for this item. Please contact us for assistance.'
        : priceState === 'incomplete'
          ? 'Please complete all required customization options before adding this item to your cart.'
          : !Number.isSafeInteger(quantity) || quantity < 1
            ? 'Please enter a valid quantity before adding this item to your cart.'
            : 'Please wait while we finish updating your customization and price.';
      showFormError(message);
      enforcePurchaseButtonState();
      return false;
    };
    let configuredPurchaseClickInFlight = false;
    const submitConfiguredViaPurchaseButton = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const primary = root.querySelector('[data-fd-atc]');
      if (!primary || primary.disabled || configuredPurchaseClickInFlight) {
        showFormError('Customization is temporarily unavailable for this item. Please contact us for assistance.');
        return;
      }
      // Keep BCPO's target click serializer for sticky and keyboard/form submissions.
      configuredPurchaseClickInFlight = true;
      try { primary.click(); } finally { configuredPurchaseClickInFlight = false; }
    };
    if (form) {
      if (usesConfiguredPurchaseGate(root)) {
        window.addEventListener('click', (event) => {
          const button = event.target && event.target.closest && event.target.closest(purchaseButtonSelector);
          if (!button || !root.contains(button) || !guardConfiguredPurchase(event)) return;
          if (button.matches('[data-fd-sticky-submit]')) submitConfiguredViaPurchaseButton(event);
        }, true);
      }
      window.addEventListener('submit', (event) => {
        if (event.target !== form) return;
        if (!guardConfiguredPurchase(event)) return;
        if (usesConfiguredPurchaseGate(root)) {
          submitConfiguredViaPurchaseButton(event);
          return;
        }
        updateConfiguredPrice();
        const conditionalState = String(root.dataset.fdConditionalState || '');
        const headrailSubmitIntegrity=!isHeadrailNeutralProduct(root)||(headrailNeutralClean(root)&&readHeadrailNeutralPrice(root,{baseCents:Number(getCurrentVariant()?.price),addOnCents:getBcpoAddOnReading().cents,currency}).ready);
        const roman001SubmitIntegrity = !isRoman001 || readRoman001PriceIntegrity(root, {
          baseCents:Number(getCurrentVariant()?.price),addOnCents:getBcpoAddOnReading().cents,currency
        }).ready;
        const roman015SubmitIntegrity = !isRoman015 || readRoman015PriceIntegrity(root, {
          baseCents:Number(getCurrentVariant()?.price),addOnCents:getBcpoAddOnReading().cents,currency
        }).ready;
        const roman014SubmitIntegrity = !isRoman014 || readRoman014PriceIntegrity(root, {baseCents:Number(getCurrentVariant()?.price),addOnCents:getBcpoAddOnReading().cents,currency}).ready;
        const roman056SubmitIntegrity = !isRoman056 || readRoman056PriceIntegrity(root, {
          baseCents:Number(getCurrentVariant()?.price),addOnCents:getBcpoAddOnReading().cents,currency
        }).ready;
        if (usesSemanticRequiredCache && (priceState !== 'ready' || conditionalState !== 'clean' || !headrailSubmitIntegrity
          || !roman001ConstraintsClean(root) || !roman001SubmitIntegrity
          || !roman015ConstraintsClean(root) || !roman015SubmitIntegrity
          || !roman056ConstraintsClean(root) || !roman056SubmitIntegrity
          || !roman014ConstraintsClean(root) || !roman014SubmitIntegrity)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const message = conditionalState === 'error' || priceState === 'error'
            ? 'Customization is temporarily unavailable for this item. Please contact us for assistance.'
            : priceState === 'incomplete'
              ? 'Please complete all required customization options before adding this item to your cart.'
              : 'Please wait while we finish updating your customization and price.';
          showFormError(message);
          enforcePurchaseButtonState();
          return;
        }
        if (isCustomizable && priceState === 'ready' && latestSnapshot) {
          syncPrivateProperties(latestSnapshot);
        }
      }, true);
    }
    updateBasePrice();
    updateSavings();
    updateConfiguredPrice();
    runPolicyCleanup();
    bindBcpoObserver();

    const maintenanceBackoff = [180, 500, 1200, 2400];
    let maintenanceAttempt = 0;
    // FD_BCPO_LAZY_PRICE_20261016: BCPO starts on the visitor's first interaction, so the page only
    // reports customization as unavailable if BCPO is still missing after that first interaction.
    let fdBcpoVisitorInteracted = false;
    let fdBcpoWaitingForInteraction = false;
    const retryMissingBcpo = () => {
      if (bindBcpoObserver()) return;
      if (maintenanceAttempt >= maintenanceBackoff.length) {
        if (isCustomizable && !fdBcpoVisitorInteracted) {
          fdBcpoWaitingForInteraction = true;
          return;
        }
        if (isCustomizable) {
          bcpoMissingFinal = true;
          scheduleUpdate();
        }
        return;
      }
      const delay = maintenanceBackoff[maintenanceAttempt];
      maintenanceAttempt += 1;
      window.setTimeout(retryMissingBcpo, delay);
    };
    const fdBcpoInteractionEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'wheel'];
    const fdBcpoOnFirstInteraction = (event) => {
      if (fdBcpoVisitorInteracted || (event && event.isTrusted === false)) return;
      fdBcpoVisitorInteracted = true;
      fdBcpoInteractionEvents.forEach((type) => window.removeEventListener(type, fdBcpoOnFirstInteraction, true));
      if (!fdBcpoWaitingForInteraction) return;
      fdBcpoWaitingForInteraction = false;
      maintenanceAttempt = 0;
      retryMissingBcpo();
    };
    fdBcpoInteractionEvents.forEach((type) => window.addEventListener(type, fdBcpoOnFirstInteraction, { capture: true, passive: true }));
    retryMissingBcpo();

    const chatBackoff = [250, 500, 1000, 2000, 3500];
    let chatAttempt = 0;
    const retryChatPolish = () => {
      if (installMobileChatPolish() || chatAttempt >= chatBackoff.length) return;
      const delay = chatBackoff[chatAttempt];
      chatAttempt += 1;
      window.setTimeout(retryChatPolish, delay);
    };
    retryChatPolish();
  };

  const run = () => {
    document.querySelectorAll(
      '.fd-pdp--p0-20260710[data-fd-product], .fd-pdp--neutral-v2[data-fd-product]'
    ).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();

/* fd-bedding-color-cards-parity-20260729 */
(function () {
  const targetHandle = 'double-layer-gauze-muslin-cotton-duvet-cover';
  const root = document.querySelector(
    `.fd-pdp.fd-pdp--p0-20260710[data-product-handle="${targetHandle}"]`
  );
  if (!root || root.dataset.fdBeddingColorCardsReady === 'true') return;
  root.dataset.fdBeddingColorCardsReady = 'true';

  const expectedColors = [
    {
      value: 'Green',
      variantId: '48131251372282',
      fileName: 'double-layer-gauze-muslin-cotton-duvet-cover-green.webp'
    },
    {
      value: 'White',
      variantId: '48131251405050',
      fileName: 'double-layer-gauze-muslin-cotton-duvet-cover-white.webp'
    },
    {
      value: 'Coffee',
      variantId: '48131251437818',
      fileName: 'double-layer-gauze-muslin-cotton-duvet-cover-coffee.webp'
    },
    {
      value: 'Light Gray',
      variantId: '48131251470586',
      fileName: 'double-layer-gauze-muslin-cotton-duvet-cover-light-gray.webp'
    },
    {
      value: 'Gray',
      variantId: '48131251503354',
      fileName: 'double-layer-gauze-muslin-cotton-duvet-cover-gray.webp'
    }
  ];
  const expectedValues = expectedColors.map((item) => item.value);
  const imagePromises = new Map();
  let mountPromise = null;
  let mountFrame = 0;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const getFileName = (src) => {
    try {
      return decodeURIComponent(new URL(String(src || ''), window.location.href).pathname.split('/').pop() || '');
    } catch (error) {
      return String(src || '').split('?')[0].split('/').pop() || '';
    }
  };

  const getThumbnailUrl = (src) => {
    try {
      const url = new URL(String(src || ''), window.location.href);
      url.searchParams.set('width', '220');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      return url.toString();
    } catch (error) {
      return String(src || '');
    }
  };

  const preloadImage = (src) => {
    if (imagePromises.has(src)) return imagePromises.get(src);
    const promise = new Promise((resolve, reject) => {
      const image = new Image();
      const finish = () => {
        if (image.naturalWidth > 0 && image.naturalHeight > 0) resolve(src);
        else reject(new Error(`Color image failed to load: ${src}`));
      };
      image.onload = finish;
      image.onerror = () => reject(new Error(`Color image failed to load: ${src}`));
      image.src = src;
      if (image.complete) finish();
    });
    imagePromises.set(src, promise);
    return promise;
  };

  const getSourceItems = () => {
    const sourceField = root.querySelector(
      '[data-fd-theme-color-option][data-fd-option-position="1"]'
    );
    if (!sourceField) return null;
    const buttons = Array.from(sourceField.querySelectorAll('[data-fd-option-value]'));
    if (buttons.length !== expectedColors.length) return null;

    const items = [];
    for (const expected of expectedColors) {
      const matches = buttons.filter(
        (button) => normalize(button.dataset.optionValue) === expected.value
      );
      if (matches.length !== 1) return null;
      const button = matches[0];
      const image = normalize(button.dataset.image);
      if (
        String(button.dataset.variantId || '') !== expected.variantId
        || getFileName(image) !== expected.fileName
      ) {
        return null;
      }
      items.push({
        value: expected.value,
        variantId: expected.variantId,
        image,
        thumbnail: getThumbnailUrl(image)
      });
    }
    return items;
  };

  const getNativeColorControl = () => {
    const select = root.querySelector(
      '#bcpo .fd-bcpo-color-option select[data-option="option1"],'
      + ' #bcpo select#bcpo-select-option-0[data-option="option1"]'
    );
    if (!select) return null;
    const wrapper = select.closest('.selector-wrapper');
    if (!wrapper) return null;
    const title = normalize(
      wrapper.querySelector('.bcpo-title')?.textContent
      || select.getAttribute('aria-label')
    ).replace(/:$/, '');
    const values = Array.from(select.options)
      .map((option) => normalize(option.value))
      .filter(Boolean);
    if (
      title.toLowerCase() !== 'color'
      || values.length !== expectedValues.length
      || values.some((value, index) => value !== expectedValues[index])
    ) {
      return null;
    }
    return { select, wrapper };
  };

  const getTrack = () => root.querySelector(
    '#bcpo .fd-bedding-color-card-track[data-fd-bedding-color-card-track]'
  );

  const syncSelectedCard = (value) => {
    const track = getTrack();
    if (!track) return;
    const selectedValue = normalize(value);
    track.querySelectorAll('[data-fd-bedding-color-value]').forEach((button) => {
      const selected = normalize(button.dataset.fdBeddingColorValue) === selectedValue
        && expectedValues.includes(selectedValue);
      button.classList.toggle('fd-bedding-color-card--selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    if (selectedValue) track.removeAttribute('data-invalid');
  };

  const setNativeValue = (select, value) => {
    const descriptor = Object.getOwnPropertyDescriptor(
      window.HTMLSelectElement.prototype,
      'value'
    );
    if (descriptor && descriptor.set) descriptor.set.call(select, value);
    else select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const restoreNativeSelect = (select) => {
    if (!select) return;
    select.classList.remove('fd-bedding-color-native-select');
    const originalTabIndex = select.dataset.fdBeddingOriginalTabIndex;
    if (originalTabIndex === '__none__') select.removeAttribute('tabindex');
    else if (typeof originalTabIndex === 'string') select.setAttribute('tabindex', originalTabIndex);
    delete select.dataset.fdBeddingOriginalTabIndex;
  };

  const removeInvalidProxy = () => {
    const track = getTrack();
    if (track) track.remove();
    root.querySelectorAll('#bcpo select.fd-bedding-color-native-select').forEach(
      restoreNativeSelect
    );
  };

  const buildProxy = async () => {
    const sourceItems = getSourceItems();
    const nativeControl = getNativeColorControl();
    if (!sourceItems || !nativeControl) {
      removeInvalidProxy();
      return false;
    }

    const signature = sourceItems
      .map((item) => `${item.value}|${item.variantId}|${getFileName(item.image)}`)
      .join('||');
    const existing = getTrack();
    if (
      existing
      && existing.dataset.fdBeddingColorSignature === signature
      && nativeControl.select.classList.contains('fd-bedding-color-native-select')
    ) {
      syncSelectedCard(nativeControl.select.value);
      return true;
    }

    try {
      await Promise.all(sourceItems.map((item) => preloadImage(item.thumbnail)));
    } catch (error) {
      removeInvalidProxy();
      return false;
    }

    const currentItems = getSourceItems();
    const currentControl = getNativeColorControl();
    if (!currentItems || !currentControl) {
      removeInvalidProxy();
      return false;
    }
    const currentSignature = currentItems
      .map((item) => `${item.value}|${item.variantId}|${getFileName(item.image)}`)
      .join('||');
    if (currentSignature !== signature) {
      removeInvalidProxy();
      return false;
    }

    if (existing) existing.remove();
    const track = document.createElement('div');
    track.className = 'fd-bedding-color-card-track';
    track.setAttribute('data-fd-bedding-color-card-track', '');
    track.dataset.fdBeddingColorSignature = signature;
    track.setAttribute('role', 'radiogroup');
    track.setAttribute('aria-label', 'Color');

    currentItems.forEach((item) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fd-bedding-color-card';
      button.dataset.fdBeddingColorValue = item.value;
      button.dataset.fdBeddingVariantId = item.variantId;
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-checked', 'false');
      button.setAttribute('aria-label', item.value);

      const image = document.createElement('span');
      image.className = 'fd-bedding-color-card__image';
      image.setAttribute('aria-hidden', 'true');
      image.style.backgroundImage = `url("${item.thumbnail.replace(/"/g, '\\"')}")`;

      const label = document.createElement('span');
      label.className = 'fd-bedding-color-card__label';
      label.textContent = item.value;

      button.append(image, label);
      track.appendChild(button);
    });

    track.addEventListener('click', (event) => {
      const button = event.target.closest('[data-fd-bedding-color-value]');
      if (!button || !track.contains(button)) return;
      const activeControl = getNativeColorControl();
      const value = normalize(button.dataset.fdBeddingColorValue);
      if (!activeControl || !expectedValues.includes(value)) return;
      syncSelectedCard(value);
      setNativeValue(activeControl.select, value);
    });

    currentControl.select.insertAdjacentElement('beforebegin', track);
    if (!Object.prototype.hasOwnProperty.call(
      currentControl.select.dataset,
      'fdBeddingOriginalTabIndex'
    )) {
      currentControl.select.dataset.fdBeddingOriginalTabIndex =
        currentControl.select.hasAttribute('tabindex')
          ? currentControl.select.getAttribute('tabindex')
          : '__none__';
    }
    currentControl.select.classList.add('fd-bedding-color-native-select');
    currentControl.select.setAttribute('tabindex', '-1');
    syncSelectedCard(currentControl.select.value);
    return true;
  };

  const mount = () => {
    if (mountPromise) return mountPromise;
    mountPromise = buildProxy().finally(() => {
      mountPromise = null;
    });
    return mountPromise;
  };

  const scheduleMount = () => {
    if (mountFrame) return;
    const run = () => {
      mountFrame = 0;
      mount();
    };
    if (window.requestAnimationFrame) mountFrame = window.requestAnimationFrame(run);
    else run();
  };

  root.addEventListener('change', (event) => {
    const nativeControl = getNativeColorControl();
    if (nativeControl && event.target === nativeControl.select) {
      syncSelectedCard(nativeControl.select.value);
    }
  }, true);

  root.addEventListener('invalid', (event) => {
    const nativeControl = getNativeColorControl();
    if (!nativeControl || event.target !== nativeControl.select) return;
    const track = getTrack();
    if (!track) return;
    track.setAttribute('data-invalid', 'true');
    const firstCard = track.querySelector('[data-fd-bedding-color-value]');
    if (firstCard) window.setTimeout(() => firstCard.focus({ preventScroll: true }), 0);
  }, true);

  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'childList')) scheduleMount();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  mount();
  window.setTimeout(scheduleMount, 600);
  window.setTimeout(scheduleMount, 1800);
  window.setTimeout(scheduleMount, 3200);
})();


/* FD_J4018_LAYER_NOTE_20260810_V2_START
 * Show a short material note only while the exact J401-8 color is selected.
 */
(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-fd-product]";
  var WRAPPER_SELECTOR = [
    "#bcpo .fd-bcpo-color-option",
    "[data-fd-template-color-field]",
    "[data-fd-theme-color-option]"
  ].join(",");
  var CHOICE_SELECTOR = [
    ".fd-bcpo-color-choice",
    "[data-fd-template-bcpo-color]",
    "[data-fd-option-value]",
    "input",
    "option"
  ].join(",");
  var NOTE_SELECTOR = "[data-fd-j4018-layer-note]";
  var TARGET_PATTERN = /(?:^|[^A-Z0-9])#?J401-8(?![A-Z0-9-])/i;

  function nodeValue(node) {
    if (!node) return "";
    return [
      node.getAttribute && node.getAttribute("data-label"),
      node.getAttribute && node.getAttribute("data-value"),
      node.getAttribute && node.getAttribute("data-option-value"),
      node.getAttribute && node.getAttribute("data-fd-color-name"),
      node.getAttribute && node.getAttribute("data-fd-current-color-value"),
      node.getAttribute && node.getAttribute("value"),
      node.getAttribute && node.getAttribute("aria-label"),
      node.getAttribute && node.getAttribute("title"),
      node.textContent
    ].filter(Boolean).join(" ");
  }

  function isTarget(node) {
    return TARGET_PATTERN.test(nodeValue(node));
  }

  function isSelected(node) {
    if (!node) return false;
    if (node.matches && node.matches("input:checked, option:checked")) return true;
    if (node.getAttribute) {
      if (node.getAttribute("aria-pressed") === "true") return true;
      if (node.getAttribute("aria-checked") === "true") return true;
    }
    if (
      node.classList &&
      (node.classList.contains("fd-bcpo-is-selected") ||
        node.classList.contains("is-selected"))
    ) {
      return true;
    }
    if (node.querySelector && node.querySelector("input:checked, option:checked")) {
      return true;
    }
    return false;
  }

  function choicesFor(wrapper) {
    return Array.prototype.slice.call(wrapper.querySelectorAll(CHOICE_SELECTOR));
  }

  function directNote(wrapper) {
    for (var i = 0; i < wrapper.children.length; i += 1) {
      if (wrapper.children[i].matches(NOTE_SELECTOR)) return wrapper.children[i];
    }
    return null;
  }

  function makeNote() {
    var note = document.createElement("p");
    note.setAttribute("data-fd-j4018-layer-note", "");
    note.setAttribute("role", "status");
    note.setAttribute("aria-live", "polite");
    note.textContent = "Rosy When Layered";
    note.hidden = true;
    note.style.cssText = [
      "box-sizing:border-box",
      "display:none",
      "width:100%",
      "grid-column:1 / -1",
      "flex-basis:100%",
      "margin:8px 0 0",
      "padding:0",
      "color:#7b6253",
      "font-size:12px",
      "font-weight:500",
      "line-height:1.4"
    ].join(";");
    return note;
  }

  function syncWrapper(wrapper) {
    var choices = choicesFor(wrapper);
    var targets = choices.filter(isTarget);
    var note = directNote(wrapper);

    if (!targets.length) {
      if (note) note.remove();
      return;
    }

    if (!note) note = makeNote();
    if (wrapper.lastElementChild !== note) wrapper.appendChild(note);

    var show = targets.some(isSelected);
    note.hidden = !show;
    note.style.display = show ? "block" : "none";
  }

  function init(root) {
    if (!root || root.getAttribute("data-fd-j4018-note-ready") === "true") return;
    root.setAttribute("data-fd-j4018-note-ready", "true");

    var queued = false;
    function sync() {
      queued = false;
      var wrappers = root.querySelectorAll(WRAPPER_SELECTOR);
      for (var i = 0; i < wrappers.length; i += 1) syncWrapper(wrappers[i]);
    }
    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    }

    root.addEventListener("click", schedule, true);
    root.addEventListener("change", schedule, true);
    root.addEventListener("input", schedule, true);
    root.addEventListener("fd:variant-updated", schedule);

    var observer = new MutationObserver(schedule);
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-pressed", "aria-checked", "checked", "value"]
    });

    sync();
    window.setTimeout(schedule, 300);
    window.setTimeout(schedule, 900);
    window.setTimeout(schedule, 1800);
  }

  function boot(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    if (base.matches && base.matches(ROOT_SELECTOR)) init(base);
    var roots = base.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i += 1) init(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
/* FD_J4018_LAYER_NOTE_20260810_V2_END */
